import React, { useRef, useState, useEffect } from "react";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import AdminMastersTemplate from "../../assets/excelSheats/MLB_Admin_Masters_V3.xlsx";
import CustVendTemplate from "../../assets/excelSheats/Customer_Vendor_Others.xlsx";
import EquipArbTemplate from "../../assets/excelSheats/MLB_Master_Data_V4.xlsx";
import moment from "moment";
import Button from "../../components/btn/Button";
import SmallModal from "../../components/modal/SmallModal";
import { HelpButton } from "../../components/btn/Buttons";
import { toast } from "react-toastify";
import { base_url } from "../../utils/utils";
import { useSelector } from "react-redux";
import TableNew from "../../components/table/TableWithPagination";
import { Alerts } from "../../components/Alerts/Alerts";
import store from "../../redux/store";
import {
  get_arb_list,
  get_staff_list,
  get_vehical_list,
  get_areacode_master_list,
  get_statutory_list,
  get_master_complete_list,
} from "../MasterData/masterdataSlice";
import axios from "axios";
import { staffOptions } from "../../utils/data";
import { pincode_verify_api } from "../../utils/apis";

const EquipmentBulkUpload = ({ isFTL, setIsFTL }) => {
  const fileInputRef = useRef(null);
  const arbFileInputRef = useRef(null);
  const staffFileInputRef = useRef(null);
  const vehicleFileInputRef = useRef(null);
  const areaCodeFileInputRef = useRef(null);
  const combinedEquipArbFileInputRef = useRef(null);
  const combinedAdminFileInputRef = useRef(null);
  const custVendFileInputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [mess, setMess] = useState("");
  const { user_id, emp_id } = useSelector((state) => state.other);
  const { master_complete_list, master_complete_loading } = useSelector((state) => state.masterdata);
  const { godown_address_list } = useSelector((state) => state.profile);
  const stateList = useSelector((state) => state.completeList.stateList || []);
  const [pageNo, setPageNo] = useState(1);
  const [entries, setEntries] = useState(10);
  const [SerchInput, setSearchInput] = useState("");
  const [excelData, setExcelData] = useState([]);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [staffData, setStaffData] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);

  useEffect(() => {
    store.dispatch(get_master_complete_list());
  }, []);

  const [arbData, setArbData] = useState([]);
  const [arbLoading, setArbLoading] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState(false);
  const [areaCodeData, setAreaCodeData] = useState([]);
  const [areaCodeLoading, setAreaCodeLoading] = useState(false);
  const [alertData, setAlertData] = useState([]);
  const [alertItemList, setAlertItemList] = useState([]);
  const [combinedEquipArbLoading, setCombinedEquipArbLoading] = useState(false);
  const [combinedAdminLoading, setCombinedAdminLoading] = useState(false);
  const [custVendData, setCustVendData] = useState([]);
  const [custVendLoading, setCustVendLoading] = useState(false);
  const [vendData, setVendData] = useState([]);
  const [omcData, setOmcData] = useState([]);
  const [othersData, setOthersData] = useState([]);
  const [pincodeVerifying, setPincodeVerifying] = useState(false);

  // Required Excel Columns (matching the actual template structure)
  const requiredColumns = [
    "GODOWN NAME",
    "Equipment",
    "Opening Stock\r\n- Filled",
    "Opening Stock\r\n- Empties",
    "Effective Date",
  ];

  const handleFileUploadClick = () => fileInputRef.current.click();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setError("");
    setExcelData([]);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
        if (!jsonData.length) {
          setError("Excel file is empty.");
          return;
        }
        const excelColumns = Object.keys(jsonData[0]);
        const missingColumns = requiredColumns.filter(
          (col) => !excelColumns.includes(col),
        );
        if (missingColumns.length > 0) {
          setError("Missing columns: " + missingColumns.join(", "));
          return;
        }
        // ✅ Map template column names → internal field names
        // ✅ Filter only rows where Row Status is "Complete"
        const filteredData = jsonData
          .filter((val) => {
            const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
            // Check for "COMPLETE", "✓ COMPLETE", or just "✓"
            return rowStatus.includes("COMPLETE") || rowStatus.includes("✓") || rowStatus.includes("✔");
          })
          .map((val) => {
            const godownName = String(val["GODOWN NAME"] || "").trim();
            const equipmentName = String(val["Equipment"] || "").trim();

            // Find godown ID by name (case-insensitive match)
            const godownMatch = (godown_address_list || []).find(
              (g) => g.UNIT_NAME?.toUpperCase() === godownName.toUpperCase()
            );

            // Find equipment/product details from master list by name
            // Equipment = CAT_NAME + CAT_DESC from master list
            const equipmentList = master_complete_list?.equipment || [];

            const equipmentMatch = equipmentList.find(
              (e) => {
                // Combine CAT_NAME and CAT_DESC from master list
                const masterFullName = `${e.CAT_NAME || ""} ${e.CAT_DESC || ""}`.trim().toUpperCase();
                const masterCatName = (e.CAT_NAME || "").trim().toUpperCase();
                const masterCatDesc = (e.CAT_DESC || "").trim().toUpperCase();

                // Normalize Excel equipment name: remove extra spaces, dashes, etc.
                const excelEquipment = equipmentName.toUpperCase().replace(/\s*-\s*/g, ' ').replace(/\s+/g, ' ').trim();
                const normalizedMasterFull = masterFullName.replace(/\s*-\s*/g, ' ').replace(/\s+/g, ' ').trim();
                const normalizedMasterDesc = masterCatDesc.replace(/\s*-\s*/g, ' ').replace(/\s+/g, ' ').trim();
                const normalizedMasterName = masterCatName.replace(/\s*-\s*/g, ' ').replace(/\s+/g, ' ').trim();

                // Try exact match first
                if (normalizedMasterFull === excelEquipment) return true;
                if (normalizedMasterDesc === excelEquipment) return true;
                if (normalizedMasterName === excelEquipment) return true;

                // Try matching CAT_NAME + CAT_DESC parts
                // e.g., "REGULATOR FTL" should match CAT_NAME="REGULATOR" + CAT_DESC="FTL"
                if (normalizedMasterName && normalizedMasterDesc) {
                  const excelParts = excelEquipment.split(' ');
                  const masterParts = normalizedMasterFull.split(' ');

                  // Check if all master parts are in excel parts in order
                  let masterIndex = 0;
                  for (let i = 0; i < excelParts.length && masterIndex < masterParts.length; i++) {
                    if (excelParts[i] === masterParts[masterIndex]) {
                      masterIndex++;
                    }
                  }
                  if (masterIndex === masterParts.length) return true;
                }

                // Fallback to partial matches
                return excelEquipment.includes(normalizedMasterDesc) ||
                  excelEquipment.includes(normalizedMasterName);
              }
            );

            return {
              PROD_CODE: equipmentMatch?.ID || "",
              CAT_NAME: equipmentMatch?.CAT_NAME || "",
              CAT_DESC: equipmentMatch?.CAT_DESC || equipmentName,
              UNITS: equipmentMatch?.UNITS || 1,
              GSTP: Number(equipmentMatch?.GST) || 0,
              CSTEH_NO: equipmentMatch?.HSN_CODE || "",
              SECURITY_DEPOSIT: Number(equipmentMatch?.SEC_DEPOSIT) || 0,
              OS_FULLS: val["Opening Stock\r\n- Filled"] || 0,
              OS_EMPTYS: val["Opening Stock\r\n- Empties"] || 0,
              EFFECTIVE_DATE: (() => {
                const d = val["Effective Date"];
                if (typeof d === "number") {
                  const parsed = XLSX.SSF.parse_date_code(d);
                  if (!parsed) return "";
                  return `${String(parsed.d).padStart(2, "0")}-${String(parsed.m).padStart(2, "0")}-${parsed.y}`;
                }
                return String(d).trim();
              })(),
              GODOWN_ID: godownMatch?.ID || "",
              GODOWN_NAME: godownName,
              OMC: JSON.parse(localStorage.getItem("userId") || '{}')?.OMC || "",
            };
          });

        if (filteredData.length === 0) {
          setError("No rows with 'Complete' status found in Excel.");
          return;
        }

        setExcelData(filteredData);
        toast.success(`Equipment Excel loaded: ${filteredData.length} rows`);
      } catch (err) {
        setError("Invalid Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const validateExcelData = () => {
    const errors = [];
    excelData.forEach((row, index) => {
      const rowNo = index + 1;
      if (!row.PROD_CODE) errors.push(`Row ${rowNo}: Equipment not found in master list`);
      if (!row.CAT_DESC) errors.push(`Row ${rowNo}: Equipment name is required`);
      if (row.OS_FULLS === "" || isNaN(row.OS_FULLS))
        errors.push(`Row ${rowNo}: Opening Full must be numeric`);
      if (row.OS_EMPTYS === "" || isNaN(row.OS_EMPTYS))
        errors.push(`Row ${rowNo}: Opening Empty must be numeric`);
      if (!moment(row.EFFECTIVE_DATE, "DD-MM-YYYY", true).isValid())
        errors.push(`Row ${rowNo}: Invalid Effective Date (DD-MM-YYYY)`);
      if (!row.GODOWN_ID || isNaN(row.GODOWN_ID))
        errors.push(`Row ${rowNo}: Godown not found - check Godown Name`);
    });
    return errors;
  };

  const handleSubmit = async () => {
    if (!excelData.length) {
      setError("Please upload Excel first.");
      return;
    }
    const validationErrors = validateExcelData();
    if (validationErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={validationErrors} />);
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("action", "create");
      formData.append("agencyid", user_id);
      formData.append("omc", JSON.parse(localStorage.getItem("userId") || '{}')?.OMC || "");
      excelData.forEach((val) => {
        formData.append("productcode[]", val.PROD_CODE);
        formData.append("unit[]", val.UNITS);
        formData.append("gst[]", val.GSTP);
        formData.append("hsn[]", val.CSTEH_NO);
        formData.append("security[]", val.SECURITY_DEPOSIT);
        formData.append("fulls[]", val.OS_FULLS);
        formData.append("emptys[]", val.OS_EMPTYS);
        formData.append("effectivedate[]", val.EFFECTIVE_DATE);
        formData.append("godown_id[]", val.GODOWN_ID);
      });
      const response = await fetch(base_url + "equipment_master_api.php", {
        method: "POST",
        body: formData,
      });
      const res = await response.json();
      setLoading(false);
      if (res.success) {
        toast.success(res.message || "Bulk upload successful");
        setExcelData([]);
        setIsFTL(false);
      } else {
        // toast.error(res.message || "Upload failed");
        setOpen(true);
        setMess(res.message);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong");
    }
  };

  // ─────────────────────────────────────────────
  // ARB MASTER
  // ─────────────────────────────────────────────
  const requiredArbColumns = [
    "Category",
    "Sub-Category",
    "Brand Name",
    "Product Description",
    "HSN/SAC Code",
    "UoM",
    "GST Rate",
    "Opening Stock",
    "Unit Purchase Price",
    "Effective Date",
  ];

  const handleArbFileClick = () => arbFileInputRef.current.click();

  const handleArbFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setArbData([]);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
        if (!jsonData.length) {
          setOpen(true);
          setMess("ARB Excel file is empty.");
          return;
        }
        const excelColumns = Object.keys(jsonData[0]);
        const missingColumns = requiredArbColumns.filter(
          (col) => !excelColumns.includes(col),
        );
        if (missingColumns.length > 0) {
          setOpen(true);
          setMess("ARB Missing columns: " + missingColumns.join(", "));
          return;
        }
        const arbMasterList = master_complete_list?.ARB || [];
        // ✅ Filter only rows where Row Status is "Complete"
        const filteredData = jsonData
          .filter((val) => {
            const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
            // Check for "COMPLETE", "✓ COMPLETE", or just "✓"
            return rowStatus.includes("COMPLETE") || rowStatus.includes("✓") || rowStatus.includes("✔");
          })
          .map((val) => {
            const uomValue = String(val["UoM"]).trim().toUpperCase();
            const subCatName = String(val["Sub-Category"]).trim().toUpperCase();

            // Resolve Sub-Category ID from name (CAT_DESC) - match from ARB master list
            let prodCode = "";
            if (subCatName) {
              const matched = arbMasterList.find(
                (item) => item.CAT_DESC?.toUpperCase() === subCatName
              );
              prodCode = matched ? matched.ID : "";
            }

            return {
              CATEGORY: val["Category"],
              PROD_CODE: prodCode,
              SUB_CATEGORY: val["Sub-Category"],
              BRAND: val["Brand Name"],
              PRODUCT_NAME: val["Product Description"],
              HSN_CODE: val["HSN/SAC Code"],
              UNIT: uomValue === "NOS" ? 1 : uomValue === "KGS" ? 2 : val["UoM"],
              GST: String(val["GST Rate"]),
              OPENING_STOCK: String(val["Opening Stock"]),
              PRICE: String(val["Unit Purchase Price"]),
              EFFECTIVE_DATE: (() => {
                const d = val["Effective Date"];
                if (typeof d === "number") {
                  const parsed = XLSX.SSF.parse_date_code(d);
                  if (!parsed) return "";
                  return `${String(parsed.d).padStart(2, "0")}-${String(parsed.m).padStart(2, "0")}-${parsed.y}`;
                }
                return String(d).trim();
              })(),
            };
          });

        if (filteredData.length === 0) {
          setOpen(true);
          setMess("No rows with 'Complete' status found in ARB Excel.");
          return;
        }

        setArbData(filteredData);
        toast.success(`ARB Excel loaded: ${filteredData.length} rows`);
      } catch (err) {
        setOpen(true);
        setMess("Invalid ARB Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const validateArbData = () => {
    const errors = [];
    arbData.forEach((row, index) => {
      const rowNo = index + 1;
      if (!row.CATEGORY) errors.push(`Row ${rowNo}: Category is required`);
      if (!row.PROD_CODE) errors.push(`Row ${rowNo}: Sub-Category is required`);
      if (!row.BRAND || !String(row.BRAND).trim())
        errors.push(`Row ${rowNo}: Brand Name is required`);
      if (!row.PRODUCT_NAME || !String(row.PRODUCT_NAME).trim())
        errors.push(`Row ${rowNo}: Product Description is required`);
      if (!row.HSN_CODE) errors.push(`Row ${rowNo}: HSN/SAC Code is required`);
      if (row.UNIT !== 1 && row.UNIT !== 2)
        errors.push(`Row ${rowNo}: UoM must be NOS or KGS`);
      if (row.GST === "" || row.GST === null || row.GST === undefined)
        errors.push(`Row ${rowNo}: GST Rate is required`);
      if (!moment(row.EFFECTIVE_DATE, "DD-MM-YYYY", true).isValid())
        errors.push(`Row ${rowNo}: Invalid Effective Date (DD-MM-YYYY)`);
      const numericPrice = parseFloat(row.PRICE);
      if (row.PRICE === "" || row.PRICE === null || row.PRICE === undefined) {
        errors.push(`Row ${rowNo}: Unit Purchase Price is required`);
      } else if (
        isNaN(numericPrice) ||
        numericPrice <= 0 ||
        numericPrice >= 10000000
      ) {
        errors.push(
          `Row ${rowNo}: Unit Purchase Price must be numeric, > 0 and < 1,00,00,000`,
        );
      }
      if (String(row.OPENING_STOCK).length === 0)
        errors.push(`Row ${rowNo}: Opening Stock is required, enter 0 if none`);
    });
    return errors;
  };

  const handleArbSubmit = async () => {
    if (!arbData.length) {
      setOpen(true);
      setMess("Please upload ARB Excel first.");
      return;
    }
    const validationErrors = validateArbData();
    if (validationErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={validationErrors} />);
      return;
    }
    try {
      setArbLoading(true);
      const body = new FormData();
      body.append("action", "create");
      body.append("agencyid", user_id);
      arbData.forEach((v) => {
        body.append("productcode[]", v.PROD_CODE);
        body.append("brand[]", String(v.BRAND).trim());
        body.append("pname[]", String(v.PRODUCT_NAME).trim());
        body.append("unit[]", v.UNIT);
        body.append("gst[]", v.GST);
        body.append("hsn[]", v.HSN_CODE);
        body.append("price[]", v.PRICE);
        body.append("stock[]", v.OPENING_STOCK);
        body.append("date[]", v.EFFECTIVE_DATE);
      });
      if (emp_id) body.append("emp_code", emp_id);
      const response = await fetch(base_url + "arb_api.php", {
        method: "POST",
        body,
      });
      const res = await response.json();
      setArbLoading(false);
      if (res.success) {
        store.dispatch(get_arb_list());
        setArbData([]);
        toast(res.message);
      } else {
        setOpen(true);
        setMess(res.message);
      }
    } catch (err) {
      setArbLoading(false);
      toast.error("Something went wrong with ARB upload");
    }
  };

  // ─────────────────────────────────────────────
  // STAFF MASTER
  // ─────────────────────────────────────────────
  // Build role name → ID map from staffOptions
  const staffRoleMap = {};
  staffOptions.forEach((opt) => {
    staffRoleMap[opt.label.toUpperCase()] = opt.value;
  });
  const staffRoleNames = staffOptions.map((opt) => opt.label);

  const requiredStaffColumns = [
    "EMPLOYEE\r\nCODE",
    "EMPLOYEE\r\nNAME",
    "DATE OF\r\nBIRTH",
    "DESIGNATION",
    "EMPLOYEE\r\nROLE",
    "JOINING\r\nDATE",
  ];

  const handleStaffFileClick = () => staffFileInputRef.current.click();
  // Normalize column keys: LibreOffice saves \n, Excel saves \r\n — ensure \r\n everywhere
  const normalizeKeys = (rows) =>
    rows.map((row) => {
      const out = {};
      for (const k in row) out[k.replace(/\r?\n/g, "\r\n")] = row[k];
      return out;
    });

  // Helper function to parse Excel date (serial number or string)
  const parseExcelDate = (val, outputFormat = "YYYY-MM-DD") => {
    if (!val) return "";

    // If it's a number, it's an Excel serial date
    if (typeof val === "number") {
      const date = XLSX.SSF.parse_date_code(val);
      if (!date) return "";
      const month = String(date.m).padStart(2, "0");
      const day = String(date.d).padStart(2, "0");
      const formatted = `${date.y}-${month}-${day}`;
      return moment(formatted, "YYYY-MM-DD").format(outputFormat);
    }

    // If it's already a string, parse normally
    return moment(val).format(outputFormat);
  };
  const handleStaffFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setStaffData([]);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
        if (!jsonData.length) {
          setOpen(true);
          setMess("Staff Excel file is empty.");
          return;
        }

        const excelColumns = Object.keys(jsonData[0]);
        const missingColumns = requiredStaffColumns.filter(
          (col) => !excelColumns.includes(col),
        );
        if (missingColumns.length > 0) {
          setOpen(true);
          setMess("Staff Missing columns: " + missingColumns.join(", "));
          return;
        }
        // ✅ Filter only rows where Row Status is "Complete" AND has data
        const filteredData = jsonData
          .filter((val) => {
            // Check Row Status first
            const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
            const isComplete = rowStatus.includes("Complete") || rowStatus.includes("✓") || rowStatus.includes("✔");

            // Then check if row has data
            const hasData = String(val["EMPLOYEE\r\nCODE"]).trim() ||
              String(val["EMPLOYEE\r\nNAME"]).trim() ||
              String(val["DESIGNATION"]).trim() ||
              String(val["EMPLOYEE\r\nROLE"]).trim();

            return isComplete && hasData;
          })
          .map((val) => {
            const roleName = String(val["EMPLOYEE\r\nROLE"]).trim().toUpperCase();
            return {
              EMP_CODE: String(val["EMPLOYEE\r\nCODE"]).trim(),
              EMP_NAME: String(val["EMPLOYEE\r\nNAME"]).trim(),
              DOB: parseExcelDate(val["DATE OF\r\nBIRTH"], "YYYY-MM-DD"),
              DESIGNATION: String(val["DESIGNATION"]).trim(),
              ROLE: staffRoleMap[roleName] !== undefined ? staffRoleMap[roleName] : val["EMPLOYEE\r\nROLE"],
              ROLE_NAME: roleName,
              JOINING_DATE: parseExcelDate(val["JOINING\r\nDATE"], "YYYY-MM-DD"),
            };
          });
        if (!filteredData.length) {
          setOpen(true);
          setMess("Staff Excel has no filled rows.");
          return;
        }
        setStaffData(filteredData);
        toast.success("Staff Excel loaded successfully");
      } catch (err) {
        setOpen(true);
        setMess("Invalid Staff Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const validateStaffData = () => {
    const errors = [];
    const codes = [];
    if (!staffData.length) {
      errors.push("Please add at least one staff entry.");
      return errors;
    }
    const validRoleIds = staffOptions.map((opt) => opt.value);
    const today = moment();
    staffData.forEach((row, index) => {
      const rowNo = index + 1;
      if (!row.EMP_CODE || !String(row.EMP_CODE).trim())
        errors.push(`Row ${rowNo}: Employee Code is required`);
      else codes.push(String(row.EMP_CODE).trim());
      if (!row.EMP_NAME || !String(row.EMP_NAME).trim())
        errors.push(`Row ${rowNo}: Employee Name is required`);

      // DOB validation
      const dobDate = moment(row.DOB, "YYYY-MM-DD", true);
      if (!row.DOB || !dobDate.isValid()) {
        errors.push(`Row ${rowNo}: Valid Date of Birth is required (YYYY-MM-DD)`);
      } else {
        if (dobDate.isAfter(today))
          errors.push(`Row ${rowNo}: Date of Birth cannot be a future date`);
        const age = today.diff(dobDate, "years");
        if (age < 14)
          errors.push(`Row ${rowNo}: Employee must be at least 14 years old`);
        if (age > 100)
          errors.push(`Row ${rowNo}: Date of Birth seems too old, please verify`);
      }

      if (!row.DESIGNATION || !String(row.DESIGNATION).trim())
        errors.push(`Row ${rowNo}: Designation is required`);
      if (!validRoleIds.includes(String(row.ROLE)))
        errors.push(`Row ${rowNo}: Role must be selected from the dropdown`);

      // Joining Date validation
      const joinDate = moment(row.JOINING_DATE, "YYYY-MM-DD", true);
      if (!row.JOINING_DATE || !joinDate.isValid()) {
        errors.push(`Row ${rowNo}: Valid Joining Date is required (YYYY-MM-DD)`);
      } else {
        if (joinDate.isAfter(today))
          errors.push(`Row ${rowNo}: Joining Date cannot be a future date`);
        if (dobDate.isValid() && joinDate.isBefore(dobDate))
          errors.push(`Row ${rowNo}: Joining Date cannot be before Date of Birth`);
        if (dobDate.isValid() && joinDate.diff(dobDate, "years") < 14)
          errors.push(`Row ${rowNo}: Joining Date must be at least 14 years after DOB`);
      }
    });
    if (new Set(codes).size !== codes.length)
      errors.push("Duplicate Employee Codes are not allowed.");
    return errors;
  };

  const handleStaffSubmit = async () => {
    if (!staffData.length) {
      setOpen(true);
      setMess("Please upload Staff Excel first.");
      return;
    }
    const validationErrors = validateStaffData();
    if (validationErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={validationErrors} />);
      return;
    }
    try {
      setStaffLoading(true);
      const body = new FormData();
      body.append("action", "create");
      body.append("agencyid", user_id);
      staffData.forEach((item) => {
        body.append("empcode[]", String(item.EMP_CODE).trim());
        body.append("empname[]", String(item.EMP_NAME).trim());
        body.append("dob[]", item.DOB);
        body.append("designation[]", String(item.DESIGNATION).trim());
        body.append("role[]", item.ROLE);
        body.append("joining[]", item.JOINING_DATE);
      });
      if (emp_id) body.append("emp_code", emp_id);
      const { data } = await axios.post(base_url + "staff_master.php", body);
      setStaffLoading(false);
      if (data.success) {
        store.dispatch(get_staff_list());
        setStaffData([]);
        toast(data.message, { position: "top-center" });
      } else {
        setOpen(true);
        setMess(data.message);
      }
    } catch (err) {
      setStaffLoading(false);
      toast.error("Something went wrong with Staff upload");
    }
  };

  // ─────────────────────────────────────────────
  // AREA CODE MASTER
  // ─────────────────────────────────────────────
  const requiredAreaCodeColumns = [
    "PINCODE",
    "AREA\r\nCODE",
    "AREA\r\nNAME",
    "DISTANCE\r\n(KM)",
    "ADDL TRANSPORT\r\nCHARGES",
    "EFFECTIVE DATE",
  ];

  const handleAreaCodeFileClick = () => areaCodeFileInputRef.current.click();

  const handleAreaCodeFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setAreaCodeData([]);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
        if (!jsonData.length) {
          setOpen(true);
          setMess("Area Code Excel file is empty.");
          return;
        }
        const excelColumns = Object.keys(jsonData[0]);
        const missingColumns = requiredAreaCodeColumns.filter(
          (col) => !excelColumns.includes(col),
        );
        if (missingColumns.length > 0) {
          setOpen(true);
          setMess("Area Code Missing columns: " + missingColumns.join(", "));
          return;
        }
        // ✅ Filter only rows where Row Status is "Complete" AND has data
        const filteredData = jsonData
          .filter((val) => {
            const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
            // Check for "COMPLETE", "✓ COMPLETE", or just "✓"
            return (rowStatus.includes("COMPLETE") || rowStatus.includes("✓") || rowStatus.includes("✔")) && (
              String(val["PINCODE"]).trim() ||
              String(val["AREA\r\nCODE"]).trim() ||
              String(val["AREA\r\nNAME"]).trim()
            );
          })
          .map((val) => ({
            PINCODE: String(val["PINCODE"]).trim(),
            AREA_CODE: String(val["AREA\r\nCODE"]).trim(),
            AREA_NAME: String(val["AREA\r\nNAME"]).trim(),
            DISTANCE: String(val["DISTANCE\r\n(KM)"]).trim(),
            CHARGE: String(val["ADDL TRANSPORT\r\nCHARGES"]).trim(),
            EFFECTIVE_DATE: parseExcelDate(val["EFFECTIVE DATE"], "YYYY-MM-DD"),
          }));
        if (!filteredData.length) {
          setOpen(true);
          setMess("Area Code Excel has no filled rows.");
          return;
        }
        setAreaCodeData(filteredData);
        toast.success("Area Code Excel loaded successfully");
      } catch (err) {
        setOpen(true);
        setMess("Invalid Area Code Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const validateAreaCodeData = () => {
    const errors = [];
    if (!areaCodeData.length) {
      errors.push("Please add at least one area code entry.");
      return errors;
    }
    const today = moment();
    const pincodeRegex = /^\d{6}$/;
    areaCodeData.forEach((row, index) => {
      const rowNo = index + 1;
      // Pincode validation - must be exactly 6 digits
      if (!row.PINCODE) {
        errors.push(`Row ${rowNo}: Pincode is required`);
      } else if (!pincodeRegex.test(row.PINCODE)) {
        errors.push(`Row ${rowNo}: Pincode must be exactly 6 digits`);
      }
      if (!row.AREA_CODE || !String(row.AREA_CODE).trim())
        errors.push(`Row ${rowNo}: Area Code is required`);
      if (!row.AREA_NAME || !String(row.AREA_NAME).trim())
        errors.push(`Row ${rowNo}: Area Name is required`);
      // Distance validation - must be numeric and positive
      if (row.DISTANCE === "" || row.DISTANCE === null || row.DISTANCE === undefined) {
        errors.push(`Row ${rowNo}: OneWay Distance is required`);
      } else if (isNaN(Number(row.DISTANCE)) || Number(row.DISTANCE) < 0) {
        errors.push(`Row ${rowNo}: OneWay Distance must be a valid positive number`);
      }
      // Charge validation - must be numeric, positive, max 99
      if (row.CHARGE === "" || row.CHARGE === null || row.CHARGE === undefined) {
        errors.push(`Row ${rowNo}: Transport Charge is required`);
      } else if (isNaN(Number(row.CHARGE)) || Number(row.CHARGE) < 0) {
        errors.push(`Row ${rowNo}: Transport Charge must be a valid positive number`);
      } else if (Number(row.CHARGE) > 999) {
        errors.push(`Row ${rowNo}: Transport Charge cannot be more than 999`);
      }
      // Date validation
      const effDate = moment(row.EFFECTIVE_DATE, "YYYY-MM-DD", true);
      if (!row.EFFECTIVE_DATE || !effDate.isValid()) {
        errors.push(`Row ${rowNo}: Valid Effective Date is required (YYYY-MM-DD)`);
      } else {
        if (effDate.isBefore(today.clone().subtract(1, "year")))
          errors.push(`Row ${rowNo}: Effective Date seems too old, please verify`);
      }
    });
    return errors;
  };

  const handleAreaCodeSubmit = async () => {
    if (!areaCodeData.length) {
      setOpen(true);
      setMess("Please upload Area Code Excel first.");
      return;
    }
    const validationErrors = validateAreaCodeData();
    if (validationErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={validationErrors} />);
      return;
    }
    try {
      setAreaCodeLoading(true);
      const body = new FormData();
      body.append("action", "create");
      body.append("agencyid", user_id);
      areaCodeData.forEach((item) => {
        body.append("pincode[]", item.PINCODE);
        body.append("areacode[]", item.AREA_CODE);
        body.append("areaname[]", item.AREA_NAME);
        body.append("distance[]", item.DISTANCE);
        body.append("charge[]", item.CHARGE);
        body.append("date[]", item.EFFECTIVE_DATE);
      });
      if (emp_id) body.append("emp_code", emp_id);
      const { data } = await axios.post(base_url + "area_code_api.php", body);
      setAreaCodeLoading(false);
      if (data.success) {
        store.dispatch(get_areacode_master_list());
        setAreaCodeData([]);
        toast(data.message, { position: "top-center" });
      } else {
        setOpen(true);
        setMess(data.message);
      }
    } catch (err) {
      setAreaCodeLoading(false);
      toast.error("Something went wrong with Area Code upload");
    }
  };

  // ─────────────────────────────────────────────
  // ALERT MASTER
  // ─────────────────────────────────────────────
  const reminderOptions = [
    { value: "0", label: "SELECT" },
    { value: "1", label: "7 DAYS" },
    { value: "2", label: "15 DAYS" },
    { value: "3", label: "30 DAYS" },
    { value: "4", label: "60 DAYS" },
  ];
  const reminderMap = {};
  reminderOptions.forEach((opt) => {
    reminderMap[opt.label.toUpperCase()] = opt.value;
  });

  const requiredAlertColumns = [
    "ITEM",
    "REFERENCE NO",
    "VALID UPTO (YYYY-MM-DD)",
    "REMINDER",
    "REMARKS",
  ];

  const fetchAlertItemList = async () => {
    try {
      const response = await fetch(base_url + "itemlistapi.php", {
        method: "POST",
        body: JSON.stringify({ agencyid: user_id }),
      });
      const res = await response.json();
      if (res.status === 200 && res.record) {
        setAlertItemList(res.record);
        return res.record;
      }
      return [];
    } catch (err) {
      toast.error("Failed to fetch item list");
      return [];
    }
  };

  const validateAlertData = () => {
    const errors = [];
    if (!alertData.length) {
      errors.push("Please add at least one alert entry.");
      return errors;
    }
    const validReminderIds = ["1", "2", "3", "4"];
    const validItemIds = alertItemList.map((it) => it.ID);
    alertData.forEach((row, index) => {
      const rowNo = index + 1;
      if (!row.ITEM_ID || !validItemIds.includes(row.ITEM_ID))
        errors.push(`Row ${rowNo}: Item must be selected from the dropdown`);
      if (!row.REFERENCE_NO || !String(row.REFERENCE_NO).trim())
        errors.push(`Row ${rowNo}: Reference No is required`);
      // Valid Upto date validation
      const validDate = moment(row.VALID_UPTO, "YYYY-MM-DD", true);
      if (!row.VALID_UPTO || !validDate.isValid()) {
        errors.push(`Row ${rowNo}: Valid Upto date is required (YYYY-MM-DD)`);
      } else {
        if (validDate.isBefore(moment(), "day"))
          errors.push(`Row ${rowNo}: Valid Upto date cannot be a past date`);
      }
      if (!validReminderIds.includes(String(row.REMINDER)))
        errors.push(`Row ${rowNo}: Reminder must be selected from the dropdown`);
    });
    return errors;
  };

  // ─────────────────────────────────────────────
  // VEHICLE MASTER
  // ─────────────────────────────────────────────
  const vehicleTypeMap = {
    "TWO WHEELER": 0,
    "THREE WHEELER": 1,
    "FOUR WHEELER": 2,
    "TRUCK": 3,
    "OTHERS": 4,
  };
  const vehicleTypeNames = Object.keys(vehicleTypeMap);

  const vehicleUsageMap = {
    "INWARD DELIVERY": 0,
    "OUTWARD DELIVERY": 1,
    "INWARD/OUTWARD DELIVERY": 2,
    "CONVEYANCE": 3,
    "OTHERS": 4,
  };
  const vehicleUsageNames = Object.keys(vehicleUsageMap);

  const requiredVehicleColumns = [
    "VEHICLE\r\nNUMBER",
    "VEHICLE\r\nMAKE",
    "VEHICLE\r\nTYPE",
    "VEHICLE\r\nUSE",
  ];

  const handleVehicleFileClick = () => vehicleFileInputRef.current.click();

  const handleVehicleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setVehicleData([]);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
        if (!jsonData.length) {
          setOpen(true);
          setMess("Vehicle Excel file is empty.");
          return;
        }
        const excelColumns = Object.keys(jsonData[0]);
        const missingColumns = requiredVehicleColumns.filter(
          (col) => !excelColumns.includes(col),
        );
        if (missingColumns.length > 0) {
          setOpen(true);
          setMess("Vehicle Missing columns: " + missingColumns.join(", "));
          return;
        }
        // ✅ Filter only rows where Row Status is "Complete" AND has data
        const filteredData = jsonData
          .filter((val) => {
            // Check Row Status first
            const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
            const isComplete = rowStatus.includes("Complete") || rowStatus.includes("✓") || rowStatus.includes("✔");

            // Then check if row has data
            const hasData = String(val["VEHICLE\r\nNUMBER"]).trim() ||
              String(val["VEHICLE\r\nMAKE"]).trim() ||
              String(val["VEHICLE\r\nTYPE"]).trim() ||
              String(val["VEHICLE\r\nUSE"]).trim();

            return isComplete && hasData;
          })
          .map((val) => {
            const typeName = String(val["VEHICLE\r\nTYPE"]).trim().toUpperCase();
            const usageName = String(val["VEHICLE\r\nUSE"]).trim().toUpperCase();
            // Normalize vehicle number: uppercase, remove spaces/hyphens
            const rawVNum = String(val["VEHICLE\r\nNUMBER"]).trim().toUpperCase().replace(/[\s-]/g, "");
            return {
              VEHICLE_NUMBER: rawVNum,
              VEHICLE_MAKE: String(val["VEHICLE\r\nMAKE"]).trim(),
              VEHICLE_TYPE: vehicleTypeMap[typeName] !== undefined ? vehicleTypeMap[typeName] : val["VEHICLE\r\nTYPE"],
              VEHICLE_TYPE_NAME: typeName,
              VEHICLE_USAGE: vehicleUsageMap[usageName] !== undefined ? vehicleUsageMap[usageName] : val["VEHICLE\r\nUSE"],
              VEHICLE_USAGE_NAME: usageName,
            };
          });
        if (!filteredData.length) {
          setOpen(true);
          setMess("Vehicle Excel has no filled rows.");
          return;
        }
        setVehicleData(filteredData);
        toast.success("Vehicle Excel loaded successfully");
      } catch (err) {
        setOpen(true);
        setMess("Invalid Vehicle Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const validateVehicleData = () => {
    const errors = [];
    if (!vehicleData.length) {
      errors.push("Please add at least one vehicle entry.");
      return errors;
    }
    const vehicleNumbers = [];
    // Indian vehicle number: 2 letters (state) + 1-2 digits (district) + 0-3 letters (series) + 1-4 digits (number)
    // e.g. KA01AB1234, MH12DE1433, TN07CK1234, DL1CAB1234
    const vehicleNumRegex = /^[A-Z]{2}\d{1,2}[A-Z]{0,3}\d{1,4}$/;
    vehicleData.forEach((row, index) => {
      const rowNo = index + 1;
      const vNum = String(row.VEHICLE_NUMBER || "").trim().toUpperCase().replace(/[\s-]/g, "");
      if (!vNum) {
        errors.push(`Row ${rowNo}: Vehicle Number is required`);
      } else if (!vehicleNumRegex.test(vNum)) {
        errors.push(`Row ${rowNo}: Invalid Vehicle Number format (e.g. KA01AB1234)`);
      } else {
        vehicleNumbers.push(vNum);
      }
      if (!row.VEHICLE_MAKE || !String(row.VEHICLE_MAKE).trim())
        errors.push(`Row ${rowNo}: Vehicle Make is required`);
      if (
        row.VEHICLE_TYPE === "" ||
        row.VEHICLE_TYPE === null ||
        row.VEHICLE_TYPE === undefined ||
        isNaN(Number(row.VEHICLE_TYPE)) ||
        ![0, 1, 2, 3, 4].includes(Number(row.VEHICLE_TYPE))
      )
        errors.push(`Row ${rowNo}: Vehicle Type is required`);
      if (
        row.VEHICLE_USAGE === "" ||
        row.VEHICLE_USAGE === null ||
        row.VEHICLE_USAGE === undefined ||
        isNaN(Number(row.VEHICLE_USAGE)) ||
        ![0, 1, 2, 3, 4].includes(Number(row.VEHICLE_USAGE))
      )
        errors.push(`Row ${rowNo}: Vehicle Usage is required`);
    });
    const uniqueVehicleNumbers = [...new Set(vehicleNumbers)];
    if (uniqueVehicleNumbers.length !== vehicleNumbers.length)
      errors.push("Duplicate Vehicle Numbers are not allowed.");
    return errors;
  };

  const handleVehicleSubmit = async () => {
    if (!vehicleData.length) {
      setOpen(true);
      setMess("Please upload Vehicle Excel first.");
      return;
    }
    const validationErrors = validateVehicleData();
    if (validationErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={validationErrors} />);
      return;
    }
    try {
      setVehicleLoading(true);
      const body = new FormData();
      body.append("action", "create");
      body.append("agencyid", user_id);
      vehicleData.forEach((item) => {
        body.append("vnumber[]", String(item.VEHICLE_NUMBER).trim());
        body.append("vmake[]", String(item.VEHICLE_MAKE).trim());
        body.append("vtype[]", item.VEHICLE_TYPE);
        body.append("vusage[]", item.VEHICLE_USAGE);
      });
      if (emp_id) body.append("emp_code", emp_id);
      const response = await axios.post(base_url + "vechical_master.php", body);
      setVehicleLoading(false);
      if (response.data.success) {
        store.dispatch(get_vehical_list());
        setVehicleData([]);
        toast(response.data.message, { position: "top-center" });
      } else {
        setOpen(true);
        setMess(response.data.message);
      }
    } catch (err) {
      setVehicleLoading(false);
      toast.error("Something went wrong with Vehicle upload");
    }
  };

  // ─────────────────────────────────────────────
  // COMBINED: EQUIPMENT + ARB MASTER
  // ─────────────────────────────────────────────
  const handleCombinedEquipArbDownload = async () => {
    try {
      const JSZip = (await import("jszip")).default;

      // Fetch template
      const response = await fetch(EquipArbTemplate);
      const arrayBuffer = await response.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);

      if (godown_address_list && godown_address_list.length > 0) {

        // =========================
        // UPDATE LISTS SHEET
        // =========================
        let sheetXml = await zip.file("xl/worksheets/sheet1.xml").async("string");

        // Remove old Godown values (I column except header)
        sheetXml = sheetXml.replace(
          /<c r="I(\d+)"(?:[^>]*\/>|[^>]*>[\s\S]*?<\/c>)/g,
          (match, rowNum) => {
            return rowNum === "1" ? match : "";
          }
        );

        // Insert Godown names
        godown_address_list.forEach((godown, index) => {

          const rowNum = index + 2;

          const cellXml = `
        <c r="I${rowNum}" t="inlineStr">
          <is>
            <t>${escapeXml(godown.UNIT_NAME || "")}</t>
          </is>
        </c>`;

          const rowRegex = new RegExp(
            `(<row[^>]*r="${rowNum}"[^>]*>)(.*?)(</row>)`,
            "s"
          );

          if (sheetXml.match(rowRegex)) {

            sheetXml = sheetXml.replace(
              rowRegex,
              (_match, rowStart, rowContent, rowEnd) => {

                const jCellIdx = rowContent.indexOf(`<c r="J${rowNum}"`);

                if (jCellIdx > -1) {
                  return (
                    rowStart +
                    rowContent.substring(0, jCellIdx) +
                    cellXml +
                    rowContent.substring(jCellIdx) +
                    rowEnd
                  );
                }

                return rowStart + rowContent + cellXml + rowEnd;
              }
            );

          } else {

            const newRow = `<row r="${rowNum}">${cellXml}</row>`;

            sheetXml = sheetXml.replace(
              "</sheetData>",
              newRow + "</sheetData>"
            );
          }
        });

        // =========================
        // INJECT EQUIPMENT into column K
        // =========================
        const equipmentList = master_complete_list?.equipment || [];

        // Remove old K column cells except header K1
        sheetXml = sheetXml.replace(
          /<c r="K(\d+)"(?:[^>]*\/>|[^>]*>[\s\S]*?<\/c>)/g,
          (match, rowNum) => (rowNum === "1" ? match : "")
        );

        equipmentList.forEach((equip, index) => {
          const rowNum = index + 2;
          const equipName = escapeXml(`${equip.CAT_NAME || ""} - ${equip.CAT_DESC || ""}`.trim());
          const cellXml = `
        <c r="K${rowNum}" t="inlineStr">
          <is>
            <t>${equipName}</t>
          </is>
        </c>`;

          const rowRegex = new RegExp(
            `(<row[^>]*r="${rowNum}"[^>]*>)(.*?)(</row>)`,
            "s"
          );

          if (sheetXml.match(rowRegex)) {
            sheetXml = sheetXml.replace(
              rowRegex,
              (_match, rowStart, rowContent, rowEnd) => {
                // Extend spans to include column K (11) so Excel doesn't discard the new cell
                rowStart = rowStart.replace(
                  /\bspans="(\d+):(\d+)"/,
                  (_, from, to) => `spans="${from}:${Math.max(parseInt(to), 11)}"`
                );
                const lCellIdx = rowContent.indexOf(`<c r="L${rowNum}"`);
                if (lCellIdx > -1) {
                  return (
                    rowStart +
                    rowContent.substring(0, lCellIdx) +
                    cellXml +
                    rowContent.substring(lCellIdx) +
                    rowEnd
                  );
                }
                return rowStart + rowContent + cellXml + rowEnd;
              }
            );
          } else {
            const newRow = `<row r="${rowNum}">${cellXml}</row>`;
            sheetXml = sheetXml.replace("</sheetData>", newRow + "</sheetData>");
          }
        });

        // =========================
        // UPDATE DIMENSION
        // =========================
        const godownLastRow = godown_address_list.length + 1;
        const equipLastRow = equipmentList.length > 0 ? equipmentList.length + 1 : godownLastRow;
        const maxLastRow = Math.max(godownLastRow, equipLastRow);

        sheetXml = sheetXml.replace(
          /<dimension ref="[^"]+"/,
          `<dimension ref="A1:K${maxLastRow}"`
        );

        zip.file("xl/worksheets/sheet1.xml", sheetXml);

        // =========================
        // UPDATE DROPDOWN RANGES
        // =========================
        let sheet2Xml = await zip.file("xl/worksheets/sheet2.xml").async("string");

        sheet2Xml = sheet2Xml.replace(
          /Lists!\$I\$2:\$I\$\d+/g,
          `Lists!$I$2:$I$${godownLastRow}`
        );

        sheet2Xml = sheet2Xml.replace(
          /Lists!\$K\$2(?::\$K\$\d+)?/g,
          `Lists!$K$2:$K$${equipLastRow}`
        );

        zip.file("xl/worksheets/sheet2.xml", sheet2Xml);
      }

      // =========================
      // GENERATE FILE
      // =========================
      const blob = await zip.generateAsync({ type: "blob" });

      saveAs(blob, "MLB_Master_Data_V4.xlsx");

    } catch (err) {

      toast.error("Failed to generate Excel");

      saveAs(EquipArbTemplate, "MLB_Master_Data_V4.xlsx");
    }
  };
  // =========================
  // XML SAFE TEXT
  // =========================
  const escapeXml = (str) => {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&apos;");
  };

  const handleCombinedEquipArbFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Check if master data is loaded
    const equipmentListCount = master_complete_list?.equipment?.length || 0;
    const arbListCount = master_complete_list?.ARB?.length || 0;


    if (master_complete_loading) {
      toast.error("Master data is still loading. Please wait a moment and try again.");
      event.target.value = null; // Reset file input
      return;
    }

    if (equipmentListCount === 0) {
      toast.error("Equipment master data not loaded. Please refresh the page and try again.");
      event.target.value = null; // Reset file input
      return;
    }

    setExcelData([]);
    setArbData([]);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        let loadedSheets = [];
        let errorMessages = [];

        // Parse Equipment Master sheet
        if (workbook.SheetNames.includes("Equipment Master")) {
          try {
            const worksheet = workbook.Sheets["Equipment Master"];
            const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
            if (jsonData.length > 0) {
              const excelColumns = Object.keys(jsonData[0]);
              const missingCols = requiredColumns.filter(
                (col) => !excelColumns.includes(col)
              );
              if (missingCols.length > 0) {
                errorMessages.push("Equipment: Missing columns - " + missingCols.join(", "));
              } else {
                // ✅ Filter only rows where Row Status is "Complete"
                const filteredData = jsonData
                  .filter((val) => {
                    const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
                    const isComplete = rowStatus.includes("Complete") || rowStatus.includes("✓") || rowStatus.includes("✔");
                    return isComplete;
                  })
                  .map((val) => {
                    const godownName = String(val["GODOWN NAME"] || "").trim();
                    const equipmentName = String(val["Equipment"] || "").trim();
                    // Find godown ID by name (case-insensitive match)
                    const godownMatch = (godown_address_list || []).find(
                      (g) => g.UNIT_NAME?.toUpperCase() === godownName.toUpperCase()
                    );

                    // Find equipment/product details from master list by name
                    // Equipment = CAT_NAME + CAT_DESC from master list
                    const equipmentList = master_complete_list?.equipment || [];

                    const equipmentMatch = equipmentList.find(
                      (e) => {
                        // Combine CAT_NAME and CAT_DESC from master list
                        // Format: "CAT_NAME - CAT_DESC" (with dash separator)
                        const masterFullName = `${e.CAT_NAME || ""} - ${e.CAT_DESC || ""}`.trim().toUpperCase();
                        const masterCatName = (e.CAT_NAME || "").trim().toUpperCase();
                        const masterCatDesc = (e.CAT_DESC || "").trim().toUpperCase();

                        // Normalize: convert multiple spaces to single space, trim
                        const excelEquipment = equipmentName.toUpperCase().replace(/\s+/g, ' ').trim();
                        const normalizedMasterFull = masterFullName.replace(/\s+/g, ' ').trim();

                        // Exact match with dash separator
                        if (normalizedMasterFull === excelEquipment) {
                          return true;
                        }

                        // Try without dash: "CAT_NAME CAT_DESC"
                        const masterWithoutDash = `${masterCatName} ${masterCatDesc}`.replace(/\s+/g, ' ').trim();
                        if (masterWithoutDash === excelEquipment) {
                          return true;
                        }

                        return false;
                      }
                    );

                    return {
                      PROD_CODE: equipmentMatch?.ID || "",
                      CAT_NAME: equipmentMatch?.CAT_NAME || "",
                      CAT_DESC: equipmentMatch?.CAT_DESC || equipmentName,
                      UNITS: equipmentMatch?.UNITS || 1,
                      GSTP: Number(equipmentMatch?.GST) || 0,
                      CSTEH_NO: equipmentMatch?.HSN_CODE || "",
                      SECURITY_DEPOSIT: Number(equipmentMatch?.SEC_DEPOSIT) || 0,
                      OS_FULLS: val["Opening Stock\r\n- Filled"] || 0,
                      OS_EMPTYS: val["Opening Stock\r\n- Empties"] || 0,
                      EFFECTIVE_DATE: (() => {
                        const d = val["Effective Date"];
                        if (typeof d === "number") {
                          const parsed = XLSX.SSF.parse_date_code(d);
                          if (!parsed) return "";
                          return `${String(parsed.d).padStart(2, "0")}-${String(parsed.m).padStart(2, "0")}-${parsed.y}`;
                        }
                        return String(d).trim();
                      })(),
                      GODOWN_ID: godownMatch?.ID || "",
                      GODOWN_NAME: godownName,
                      OMC: JSON.parse(localStorage.getItem("userId") || '{}')?.OMC || "",
                    };
                  });

                if (filteredData.length > 0) {
                  setExcelData(filteredData);
                  loadedSheets.push(`Equipment (${filteredData.length} rows)`);
                } else {
                  errorMessages.push("Equipment: No rows with 'Complete' status found");
                }
              }
            }
          } catch (err) {
            errorMessages.push("Equipment: Invalid sheet format");
          }
        }

        // Parse ARB Master sheet
        if (workbook.SheetNames.includes("ARB Master") || workbook.SheetNames.includes("NFR-BLPG Products Master")) {
          try {
            const sheetName = workbook.SheetNames.includes("ARB Master") ? "ARB Master" : "NFR-BLPG Products Master";
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
            if (jsonData.length > 0) {
              const excelColumns = Object.keys(jsonData[0]);
              const missingCols = requiredArbColumns.filter(
                (col) => !excelColumns.includes(col)
              );
              if (missingCols.length > 0) {
                errorMessages.push("ARB: Missing columns - " + missingCols.join(", "));
              } else {
                const arbMasterList = master_complete_list?.ARB || [];
                // ✅ Filter only rows where Row Status is "Complete"
                const filteredData = jsonData
                  .filter((val) => {
                    const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
                    const isComplete = rowStatus.includes("Complete") || rowStatus.includes("✓") || rowStatus.includes("✔");

                    return isComplete;
                  })
                  .map((val) => {
                    const uomValue = String(val["UoM"]).trim().toUpperCase();
                    const subCatName = String(val["Sub-Category"]).trim().toUpperCase();

                    // Resolve Sub-Category ID from name (CAT_DESC) - match from ARB master list
                    let prodCode = "";
                    if (subCatName) {
                      const matched = arbMasterList.find(
                        (item) => item.CAT_DESC?.toUpperCase() === subCatName
                      );
                      prodCode = matched ? matched.ID : "";
                    }

                    return {
                      CATEGORY: val["Category"],
                      PROD_CODE: prodCode,
                      SUB_CATEGORY: val["Sub-Category"],
                      BRAND: val["Brand Name"],
                      PRODUCT_NAME: val["Product Description"],
                      HSN_CODE: val["HSN/SAC Code"],
                      UNIT: uomValue === "NOS" ? 1 : uomValue === "KGS" ? 2 : val["UoM"],
                      GST: String(val["GST Rate"]),
                      OPENING_STOCK: String(val["Opening Stock"]),
                      PRICE: String(val["Unit Purchase Price"]),
                      EFFECTIVE_DATE: (() => {
                        const d = val["Effective Date"];
                        if (typeof d === "number") {
                          const parsed = XLSX.SSF.parse_date_code(d);
                          if (!parsed) return "";
                          return `${String(parsed.d).padStart(2, "0")}-${String(parsed.m).padStart(2, "0")}-${parsed.y}`;
                        }
                        return String(d).trim();
                      })(),
                    };
                  });

                if (filteredData.length > 0) {
                  setArbData(filteredData);
                  loadedSheets.push(`ARB (${filteredData.length} rows)`);
                } else {
                  errorMessages.push("ARB: No rows with 'Complete' status found");
                }
              }
            }
          } catch (err) {
            errorMessages.push("ARB: Invalid sheet format");
          }
        }

        if (loadedSheets.length > 0) {
          toast.success("Loaded: " + loadedSheets.join(", "));
        }
        if (errorMessages.length > 0) {
          setOpen(true);
          setMess(<Alerts data={errorMessages} />);
        }
        if (loadedSheets.length === 0 && errorMessages.length === 0) {
          toast.warn("No valid sheets found in the uploaded file.");
        }
      } catch (err) {
        setOpen(true);
        setMess("Invalid Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const handleCombinedEquipArbSubmit = async () => {
    if (!excelData.length && !arbData.length) {
      toast.error("Please upload Excel first.");
      return;
    }
    const allErrors = [];
    if (excelData.length > 0) {
      const eqErrors = validateExcelData();
      if (eqErrors.length > 0) allErrors.push(...eqErrors.map((e) => `[Equipment] ${e}`));
    }
    if (arbData.length > 0) {
      const arbErrors = validateArbData();
      if (arbErrors.length > 0) allErrors.push(...arbErrors.map((e) => `[ARB] ${e}`));
    }
    if (allErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={allErrors} />);
      return;
    }
    try {
      setCombinedEquipArbLoading(true);
      if (excelData.length > 0) {
        const formData = new FormData();
        formData.append("action", "create");
        formData.append("agencyid", user_id);
        formData.append("omc", JSON.parse(localStorage.getItem("userId") || '{}')?.OMC || "");
        excelData.forEach((val) => {
          formData.append("productcode[]", val.PROD_CODE);
          formData.append("unit[]", val.UNITS);
          formData.append("gst[]", val.GSTP);
          formData.append("hsn[]", val.CSTEH_NO);
          formData.append("security[]", val.SECURITY_DEPOSIT);
          formData.append("fulls[]", val.OS_FULLS);
          formData.append("emptys[]", val.OS_EMPTYS);
          formData.append("effectivedate[]", val.EFFECTIVE_DATE);
          formData.append("godown_id[]", val.GODOWN_ID);
        });
        const response = await fetch(base_url + "equipment_master_api.php", {
          method: "POST",
          body: formData,
        });
        const res = await response.json();
        if (res.success) {
          setExcelData([]);
        } else {
          setOpen(true);
          setMess(res.message);
          setCombinedEquipArbLoading(false);
          return;
        }
      }
      if (arbData.length > 0) {
        const body = new FormData();
        body.append("action", "create");
        body.append("agencyid", user_id);
        arbData.forEach((v) => {
          body.append("productcode[]", v.PROD_CODE);
          body.append("brand[]", String(v.BRAND).trim());
          body.append("pname[]", String(v.PRODUCT_NAME).trim());
          body.append("unit[]", v.UNIT);
          body.append("gst[]", v.GST);
          body.append("hsn[]", v.HSN_CODE);
          body.append("price[]", v.PRICE);
          body.append("stock[]", v.OPENING_STOCK);
          body.append("date[]", v.EFFECTIVE_DATE);
        });
        if (emp_id) body.append("emp_code", emp_id);
        const response = await fetch(base_url + "arb_api.php", {
          method: "POST",
          body,
        });
        const res = await response.json();
        if (res.success) {
          store.dispatch(get_arb_list());
          setArbData([]);
        } else {
          setOpen(true);
          setMess(res.message);
          setCombinedEquipArbLoading(false);
          return;
        }
      }
      setCombinedEquipArbLoading(false);
      toast.success("All data submitted successfully");
      setIsFTL(false);
    } catch (err) {
      setCombinedEquipArbLoading(false);
      toast.error("Something went wrong");
    }
  };

  // ─────────────────────────────────────────────
  // COMBINED: STAFF + VEHICLE + AREA CODE MASTER
  // ─────────────────────────────────────────────
  const handleCombinedAdminDownload = async () => {
    try {
      let items = alertItemList;
      if (!items.length) {
        items = await fetchAlertItemList();
      }
      const itemNames = items.map((it) => it.ITEM);

      const response = await fetch(AdminMastersTemplate);
      const arrayBuffer = await response.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);

      if (itemNames.length > 0) {
        const escXml = (s) => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

        // Read workbook.xml + rels once to locate both sheets
        const wbXml = await zip.file("xl/workbook.xml").async("string");
        const relsXml = await zip.file("xl/_rels/workbook.xml.rels").async("string");
        const getSheetPath = (name) => {
          const m = wbXml.match(new RegExp(`<sheet\\b[^>]*\\bname="${name}"[^>]*\\br:id="([^"]+)"`));
          if (!m) return null;
          const r = relsXml.match(new RegExp(`Id="${m[1]}"[^>]+Target="([^"]+)"`));
          return r ? "xl/" + r[1] : null;
        };

        // ── 1. Populate Lists sheet column G with API items ──
        const listsPath = getSheetPath("Lists");
        if (listsPath) {
          let listsXml = await zip.file(listsPath).async("string");

          // Remove any stale G column cells (skip G1 header)
          listsXml = listsXml.replace(/<c r="G(?!1")\d+"(?:\s[^>]*)?>[\s\S]*?<\/c>/g, "");

          // Write each item into G2, G3, G4...
          for (let i = 0; i < itemNames.length; i++) {
            const rowNum = i + 2;
            const cell = `<c r="G${rowNum}" t="inlineStr"><is><t>${escXml(itemNames[i])}</t></is></c>`;
            const rowRe = new RegExp(`(<row\\b[^>]*\\br="${rowNum}"[^>]*>[\\s\\S]*?)(</row>)`);
            if (rowRe.test(listsXml)) {
              listsXml = listsXml.replace(rowRe, `$1${cell}$2`);
            } else {
              listsXml = listsXml.replace("</sheetData>", `<row r="${rowNum}">${cell}</row></sheetData>`);
            }
          }

          zip.file(listsPath, listsXml);
        }

        // ── 2. Update Alert Master ITEM formula1 to exact range size ──
        const alertPath = getSheetPath("Alert Master");
        if (alertPath) {
          let alertXml = await zip.file(alertPath).async("string");
          alertXml = alertXml.replace(
            /(<dataValidation\b[^>]*sqref="A[^"]*"[^>]*>[\s\S]*?<formula1>)[^<]*(<\/formula1>)/,
            `$1Lists!$G$2:$G$${itemNames.length + 1}$2`
          );
          zip.file(alertPath, alertXml);
        }
      }

      const output = await zip.generateAsync({ type: "arraybuffer", compression: "DEFLATE" });
      saveAs(
        new Blob([output], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
        "MLB_Admin_Masters_V3.xlsx"
      );
    } catch (err) {
      toast.error("Failed to generate Excel template");
    }
  };

  const handleCombinedAdminFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setStaffData([]);
    setVehicleData([]);
    setAreaCodeData([]);
    setAlertData([]);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        let loadedSheets = [];
        let errorMessages = [];

        // Parse Staff Master sheet
        if (workbook.SheetNames.includes("Staff Master")) {
          try {
            const worksheet = workbook.Sheets["Staff Master"];
            const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
            if (jsonData.length > 0) {
              const excelColumns = Object.keys(jsonData[0]);
              const missingCols = requiredStaffColumns.filter(
                (col) => !excelColumns.includes(col)
              );
              if (missingCols.length > 0) {
                errorMessages.push("Staff: Missing columns - " + missingCols.join(", "));
              } else {
                // ✅ Filter only rows where Row Status is "Complete" AND has data
                const filteredData = jsonData
                  .filter((val) => {
                    // Check Row Status first
                    const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
                    const isComplete = rowStatus.includes("Complete") || rowStatus.includes("✓") || rowStatus.includes("✔");

                    // Then check if row has data
                    const hasData = String(val["EMPLOYEE\r\nCODE"]).trim() ||
                      String(val["EMPLOYEE\r\nNAME"]).trim() ||
                      String(val["DESIGNATION"]).trim() ||
                      String(val["EMPLOYEE\r\nROLE"]).trim();

                    return isComplete && hasData;
                  })
                  .map((val) => {
                    const roleName = String(val["EMPLOYEE\r\nROLE"]).trim().toUpperCase();
                    return {
                      EMP_CODE: String(val["EMPLOYEE\r\nCODE"]).trim(),
                      EMP_NAME: String(val["EMPLOYEE\r\nNAME"]).trim(),
                      DOB: parseExcelDate(val["DATE OF\r\nBIRTH"], "YYYY-MM-DD"),
                      DESIGNATION: String(val["DESIGNATION"]).trim(),
                      ROLE: staffRoleMap[roleName] !== undefined ? staffRoleMap[roleName] : val["EMPLOYEE\r\nROLE"],
                      ROLE_NAME: roleName,
                      JOINING_DATE: parseExcelDate(val["JOINING\r\nDATE"], "YYYY-MM-DD"),
                    };
                  });
                if (filteredData.length > 0) {
                  setStaffData(filteredData);
                  loadedSheets.push(`Staff (${filteredData.length} rows)`);
                } else {
                  errorMessages.push("Staff: No valid data rows found");
                }
              }
            }
          } catch (err) {
            errorMessages.push("Staff: Invalid sheet format");
          }
        }

        // Parse Vehicle Master sheet
        if (workbook.SheetNames.includes("Vehicle Master")) {
          try {
            const worksheet = workbook.Sheets["Vehicle Master"];
            const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
            if (jsonData.length > 0) {
              const excelColumns = Object.keys(jsonData[0]);
              const missingCols = requiredVehicleColumns.filter(
                (col) => !excelColumns.includes(col)
              );
              if (missingCols.length > 0) {
                errorMessages.push("Vehicle: Missing columns - " + missingCols.join(", "));
              } else {
                // ✅ Filter only rows where Row Status is "Complete" AND has data
                const filteredData = jsonData
                  .filter((val) => {
                    // Check Row Status first
                    const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
                    const isComplete = rowStatus.includes("Complete") || rowStatus.includes("✓") || rowStatus.includes("✔");

                    // Then check if row has data
                    const hasData = String(val["VEHICLE\r\nNUMBER"]).trim() ||
                      String(val["VEHICLE\r\nMAKE"]).trim() ||
                      String(val["VEHICLE\r\nTYPE"]).trim() ||
                      String(val["VEHICLE\r\nUSE"]).trim();

                    return isComplete && hasData;
                  })
                  .map((val) => {
                    const typeName = String(val["VEHICLE\r\nTYPE"]).trim().toUpperCase();
                    const usageName = String(val["VEHICLE\r\nUSE"]).trim().toUpperCase();
                    const rawVNum = String(val["VEHICLE\r\nNUMBER"]).trim().toUpperCase().replace(/[\s-]/g, "");
                    return {
                      VEHICLE_NUMBER: rawVNum,
                      VEHICLE_MAKE: String(val["VEHICLE\r\nMAKE"]).trim(),
                      VEHICLE_TYPE: vehicleTypeMap[typeName] !== undefined ? vehicleTypeMap[typeName] : val["VEHICLE\r\nTYPE"],
                      VEHICLE_TYPE_NAME: typeName,
                      VEHICLE_USAGE: vehicleUsageMap[usageName] !== undefined ? vehicleUsageMap[usageName] : val["VEHICLE\r\nUSE"],
                      VEHICLE_USAGE_NAME: usageName,
                    };
                  });
                if (filteredData.length > 0) {
                  setVehicleData(filteredData);
                  loadedSheets.push(`Vehicle (${filteredData.length} rows)`);
                } else {
                  errorMessages.push("Vehicle: No valid data rows found");
                }
              }
            }
          } catch (err) {
            errorMessages.push("Vehicle: Invalid sheet format");
          }
        }

        // Parse Area Code Master sheet
        if (workbook.SheetNames.includes("Area Code Master")) {
          try {
            const worksheet = workbook.Sheets["Area Code Master"];
            const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
            if (jsonData.length > 0) {
              const excelColumns = Object.keys(jsonData[0]);
              const missingCols = requiredAreaCodeColumns.filter(
                (col) => !excelColumns.includes(col)
              );
              if (missingCols.length > 0) {
                errorMessages.push("Area Code: Missing columns - " + missingCols.join(", "));
              } else {
                // ✅ Filter only rows where Row Status is "Complete" AND has data
                const filteredData = jsonData
                  .filter((val) => {
                    const rowStatus = String(val["Row\r\nStatus"] || "").trim().toUpperCase();
                    const hasData = String(val["PINCODE"]).trim() ||
                      String(val["AREA\r\nCODE"]).trim() ||
                      String(val["AREA\r\nNAME"]).trim();
                    const isComplete = rowStatus.includes("Complete") || rowStatus.includes("✓") || rowStatus.includes("✔");

                    return isComplete && hasData;
                  })
                  .map((val) => ({
                    PINCODE: String(val["PINCODE"]).trim(),
                    AREA_CODE: String(val["AREA\r\nCODE"]).trim(),
                    AREA_NAME: String(val["AREA\r\nNAME"]).trim(),
                    DISTANCE: String(val["DISTANCE\r\n(KM)"]).trim(),
                    CHARGE: String(val["ADDL TRANSPORT\r\nCHARGES"]).trim(),
                    EFFECTIVE_DATE: parseExcelDate(val["EFFECTIVE DATE"], "YYYY-MM-DD"),
                  }));
                if (filteredData.length > 0) {
                  setAreaCodeData(filteredData);
                  loadedSheets.push(`Area Code (${filteredData.length} rows)`);
                } else {
                  errorMessages.push("Area Code: No rows with 'Complete' status found");
                }
              }
            }
          } catch (err) {
            errorMessages.push("Area Code: Invalid sheet format");
          }
        }

        // Parse Alert Master sheet
        if (workbook.SheetNames.includes("Alert Master")) {
          try {
            const worksheet = workbook.Sheets["Alert Master"];
            const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(worksheet, { defval: "" }));
            if (jsonData.length > 0) {
              const excelColumns = Object.keys(jsonData[0]);
              const missingCols = requiredAlertColumns.filter(
                (col) => !excelColumns.includes(col)
              );
              if (missingCols.length > 0) {
                errorMessages.push("Alert: Missing columns - " + missingCols.join(", "));
              } else {
                const filteredData = jsonData
                  .filter((val) =>
                    String(val["ITEM"]).trim() ||
                    String(val["REFERENCE NO"]).trim() ||
                    String(val["REMARKS"]).trim()
                  )
                  .map((val) => {
                    const itemName = String(val["ITEM"]).trim().toUpperCase();
                    const reminderName = String(val["REMINDER"]).trim().toUpperCase();
                    const matchedItem = alertItemList.find(
                      (it) => it.ITEM.toUpperCase() === itemName
                    );
                    return {
                      ITEM_ID: matchedItem ? matchedItem.ID : "",
                      ITEM_NAME: String(val["ITEM"]).trim(),
                      REFERENCE_NO: String(val["REFERENCE NO"]).trim(),
                      VALID_UPTO: parseExcelDate(val["VALID UPTO (YYYY-MM-DD)"], "YYYY-MM-DD"),
                      REMINDER: reminderMap[reminderName] !== undefined ? reminderMap[reminderName] : val["REMINDER"],
                      REMINDER_NAME: reminderName,
                      REMARKS: String(val["REMARKS"]).trim(),
                    };
                  });
                if (filteredData.length > 0) {
                  setAlertData(filteredData);
                  loadedSheets.push(`Alert (${filteredData.length} rows)`);
                } else {
                  errorMessages.push("Alert: No valid data rows found");
                }
              }
            }
          } catch (err) {
            errorMessages.push("Alert: Invalid sheet format");
          }
        }

        if (loadedSheets.length > 0) {
          toast.success("Loaded: " + loadedSheets.join(", "));
        }
        if (errorMessages.length > 0) {
          setOpen(true);
          setMess(<Alerts data={errorMessages} />);
        }
        if (loadedSheets.length === 0 && errorMessages.length === 0) {
          toast.warn("No valid sheets found in the uploaded file.");
        }
      } catch (err) {
        setOpen(true);
        setMess("Invalid Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const handleCombinedAdminSubmit = async () => {
    if (!staffData.length && !vehicleData.length && !areaCodeData.length && !alertData.length) {
      toast.error("Please upload Excel first.");
      return;
    }
    const allErrors = [];
    if (staffData.length > 0) {
      const sErr = validateStaffData();
      if (sErr.length > 0) allErrors.push(...sErr.map((e) => `[Staff] ${e}`));
    }
    if (vehicleData.length > 0) {
      const vErr = validateVehicleData();
      if (vErr.length > 0) allErrors.push(...vErr.map((e) => `[Vehicle] ${e}`));
    }
    if (areaCodeData.length > 0) {
      const aErr = validateAreaCodeData();
      if (aErr.length > 0) allErrors.push(...aErr.map((e) => `[Area Code] ${e}`));
    }
    if (alertData.length > 0) {
      const alErr = validateAlertData();
      if (alErr.length > 0) allErrors.push(...alErr.map((e) => `[Alert] ${e}`));
    }
    if (allErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={allErrors} />);
      return;
    }
    try {
      setCombinedAdminLoading(true);
      if (staffData.length > 0) {
        const body = new FormData();
        body.append("action", "create");
        body.append("agencyid", user_id);
        staffData.forEach((item) => {
          body.append("empcode[]", String(item.EMP_CODE).trim());
          body.append("empname[]", String(item.EMP_NAME).trim());
          body.append("dob[]", item.DOB);
          body.append("designation[]", String(item.DESIGNATION).trim());
          body.append("role[]", item.ROLE);
          body.append("joining[]", item.JOINING_DATE);
        });
        if (emp_id) body.append("emp_code", emp_id);
        const { data } = await axios.post(base_url + "staff_master.php", body);
        if (data.success) {
          store.dispatch(get_staff_list());
          setStaffData([]);
        } else {
          setOpen(true);
          setMess(data.message);
          setCombinedAdminLoading(false);
          return;
        }
      }
      if (vehicleData.length > 0) {
        const body = new FormData();
        body.append("action", "create");
        body.append("agencyid", user_id);
        vehicleData.forEach((item) => {
          body.append("vnumber[]", String(item.VEHICLE_NUMBER).trim());
          body.append("vmake[]", String(item.VEHICLE_MAKE).trim());
          body.append("vtype[]", item.VEHICLE_TYPE);
          body.append("vusage[]", item.VEHICLE_USAGE);
        });
        if (emp_id) body.append("emp_code", emp_id);
        const response = await axios.post(base_url + "vechical_master.php", body);
        if (response.data.success) {
          store.dispatch(get_vehical_list());
          setVehicleData([]);
        } else {
          setOpen(true);
          setMess(response.data.message);
          setCombinedAdminLoading(false);
          return;
        }
      }
      if (areaCodeData.length > 0) {
        const body = new FormData();
        body.append("action", "create");
        body.append("agencyid", user_id);
        areaCodeData.forEach((item) => {
          body.append("pincode[]", item.PINCODE);
          body.append("areacode[]", item.AREA_CODE);
          body.append("areaname[]", item.AREA_NAME);
          body.append("distance[]", item.DISTANCE);
          body.append("charge[]", item.CHARGE);
          body.append("date[]", item.EFFECTIVE_DATE);
        });
        if (emp_id) body.append("emp_code", emp_id);
        const { data } = await axios.post(base_url + "area_code_api.php", body);
        if (data.success) {
          store.dispatch(get_areacode_master_list());
          setAreaCodeData([]);
        } else {
          setOpen(true);
          setMess(data.message);
          setCombinedAdminLoading(false);
          return;
        }
      }
      if (alertData.length > 0) {
        const body = new FormData();
        body.append("action", "create");
        body.append("agencyid", user_id);
        alertData.forEach((item) => {
          body.append("item[]", item.ITEM_ID);
          body.append("refrence[]", item.REFERENCE_NO);
          body.append("valid[]", item.VALID_UPTO);
          body.append("remind[]", item.REMINDER);
          body.append("remark[]", item.REMARKS);
        });
        if (emp_id) body.append("emp_code", emp_id);
        const { data } = await axios.post(base_url + "statutory_data.php", body);
        if (data.success) {
          store.dispatch(get_statutory_list());
          setAlertData([]);
        } else {
          setOpen(true);
          setMess(data.message);
          setCombinedAdminLoading(false);
          return;
        }
      }
      setCombinedAdminLoading(false);
      toast.success("All data submitted successfully");
    } catch (err) {
      setCombinedAdminLoading(false);
      toast.error("Something went wrong");
    }
  };

  // ─────────────────────────────────────────────
  // CUSTOMER / VENDOR / OMC / OTHERS MASTER
  // ─────────────────────────────────────────────
  const handleCustVendDownload = async () => {
    try {
      let states = Array.isArray(stateList) ? stateList : [];
      if (!states.length) {
        const response = await fetch(base_url + "completelist.php", { method: "POST" });
        const res = await response.json();
        if (res?.success && res?.data?.reponselist?.states) {
          states = res.data.reponselist.states;
        }
      }

      if (!states.length) {
        toast.error("State list not available. Downloading default template.");
        saveAs(CustVendTemplate, "Customer_Vendor_Others.xlsx");
        return;
      }

      const response = await fetch(CustVendTemplate);
      const arrayBuffer = await response.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);

      // Read workbook.xml + rels once to locate Lists sheet
      const wbXml = await zip.file("xl/workbook.xml").async("string");
      const relsXml = await zip.file("xl/_rels/workbook.xml.rels").async("string");
      const getSheetPath = (name) => {
        const m = wbXml.match(new RegExp(`<sheet\\b[^>]*\\bname="${name}"[^>]*\\br:id="([^"]+)"`));
        if (!m) return null;
        const r = relsXml.match(new RegExp(`Id="${m[1]}"[^>]+Target="([^"]+)"`));
        return r ? "xl/" + r[1] : null;
      };

      const cleanStates = states.filter((st) => st && String(st.name || "").trim().length > 0);

      // 1) Update Lists sheet column C with state names
      const listsPath = getSheetPath("Lists");
      if (listsPath) {
        let listsXml = await zip.file(listsPath).async("string");

        // Remove old C column cells except header C1 (handle both self-closing and content tags)
        listsXml = listsXml.replace(
          /<c r="C(\d+)"(?:[^>]*\/>|[^>]*>[\s\S]*?<\/c>)/g,
          (match, rowNum) => (rowNum === "1" ? match : "")
        );

        // Insert each state into C2, C3, ...
        cleanStates.forEach((st, index) => {
          const rowNum = index + 2;
          const name = escapeXml(String(st.name).trim());
          const cellXml = `<c r="C${rowNum}" t="inlineStr"><is><t>${name}</t></is></c>`;

          const rowRegex = new RegExp(
            `(<row[^>]*r="${rowNum}"[^>]*>)(.*?)(</row>)`,
            "s"
          );

          if (listsXml.match(rowRegex)) {
            listsXml = listsXml.replace(
              rowRegex,
              (_match, rowStart, rowContent, rowEnd) => {
                return rowStart + rowContent + cellXml + rowEnd;
              }
            );
          } else {
            // Insert new row in correct order (before the next higher-numbered row)
            const newRow = `<row r="${rowNum}" spans="1:3">${cellXml}</row>`;
            const nextRowMatch = listsXml.match(
              new RegExp(`<row[^>]*r="(\\d+)"`, "g")
            );
            let inserted = false;
            if (nextRowMatch) {
              for (const m of nextRowMatch) {
                const existingRow = parseInt(m.match(/r="(\d+)"/)[1]);
                if (existingRow > rowNum) {
                  listsXml = listsXml.replace(
                    new RegExp(`(<row[^>]*r="${existingRow}")`),
                    newRow + `$1`
                  );
                  inserted = true;
                  break;
                }
              }
            }
            if (!inserted) {
              listsXml = listsXml.replace("</sheetData>", newRow + "</sheetData>");
            }
          }
        });

        // Update dimension to cover all state rows (keep at least row 11 for warning text)
        const lastRow = Math.max(cleanStates.length + 1, 11);
        listsXml = listsXml.replace(
          /<dimension ref="[^"]+"/,
          `<dimension ref="A1:C${lastRow}"`
        );

        zip.file(listsPath, listsXml);
      }

      const output = await zip.generateAsync({ type: "blob" });

      saveAs(
        new Blob([output], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        "Customer_Vendor_Others.xlsx"
      );
    } catch (err) {
      toast.error("Failed to generate Customer/Vendor/Others Excel. Downloading default template.");
      saveAs(CustVendTemplate, "Customer_Vendor_Others.xlsx");
    }
  };

  const handleCustVendFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setCustVendData([]);
    setVendData([]);
    setOmcData([]);
    setOthersData([]);
    setPincodeVerifying(true);
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        let loadedInfo = [];

        // Helper: build colMap and getCol for any sheet's jsonData
        const makeGetCol = (jsonData) => {
          const colMap = {};
          Object.keys(jsonData[0]).forEach((col) => { colMap[col.trim().replace(/\r?\n/g, " ").toUpperCase()] = col; });
          return (row, name) => String(row[colMap[name] || name] || "").trim();
        };

        const resolveStateCode = (raw) => {
          const value = String(raw || "").trim();
          if (!value) return "";

          // Support formats like "07 - DELHI"
          let codeCandidate = value;
          let nameCandidate = "";
          const dashIndex = value.indexOf("-");
          if (dashIndex !== -1) {
            codeCandidate = value.slice(0, dashIndex).trim();
            nameCandidate = value.slice(dashIndex + 1).trim();
          }

          const upperValue = value.toUpperCase();
          const upperCode = codeCandidate.toUpperCase();
          const upperName = (nameCandidate || value).toUpperCase();

          // Try by exact code
          const byCode = (stateList || []).find(
            (s) => String(s?.code || "").toUpperCase() === upperCode
          );
          if (byCode) return String(byCode.code);

          // Try by exact name (from code-name split or whole cell)
          const byName = (stateList || []).find(
            (s) => String(s?.name || "").toUpperCase() === upperName
          );
          if (byName) return String(byName.code);

          // Finally, fall back to raw value for debugging rather than dropping it
          return upperValue;
        };

        let parsedCust = [];
        let parsedVend = [];
        let parsedOmc = [];
        let parsedOth = [];

        // ── Parse Customer sheet ──
        const customerSheetName = workbook.SheetNames.find((n) => n.trim().toUpperCase() === "CUSTOMER");
        if (customerSheetName) {
          const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(workbook.Sheets[customerSheetName], { defval: "" }));
          if (jsonData.length > 0) {
            const getCol = makeGetCol(jsonData);
            parsedCust = jsonData
              .filter((val) => getCol(val, "CUSTOMER TRADE NAME"))
              .map((val) => {
                const gstReg = getCol(val, "GST REGISTRATION").toUpperCase();
                const domVal = getCol(val, "DOMESTIC CYL").toUpperCase();
                const comVal = (getCol(val, "COMERCIAL CYL") || getCol(val, "COMMERCIAL CYL")).toUpperCase();
                const payTermRaw = (
                  getCol(val, "PREFERRED PAYMENT METHOD") ||
                  getCol(val, "PAYMENT METHOD") ||
                  getCol(val, "PREFERRED PAYMENT") ||
                  getCol(val, "PAYMENT TERMS") ||
                  getCol(val, "PAYMENT_TERMS")
                ).toUpperCase();
                const paymentTerms = gstReg === "YES" ? (payTermRaw === "CREDIT" || payTermRaw === "2" ? "2" : "1") : "0";
                return {
                  CNAME: getCol(val, "CUSTOMER TRADE NAME"),
                  EMAIL: getCol(val, "EMAIL ID"),
                  ADDRESS1: getCol(val, "BILLING ADDRESS"),
                  DISTRICT1: getCol(val, "DISTRICT"),
                  LOCATION1: getCol(val, "LOCATION"),
                  PINCODE1: getCol(val, "PIN CODE"),
                  CONTACT: getCol(val, "MOBILE NO"),
                  STATE1: resolveStateCode(
                    getCol(val, "STATE") || getCol(val, "STATES")
                  ),
                  CTYPE: "1",
                  GST_REG: gstReg === "YES" ? "1" : "2",
                  GSTIN: getCol(val, "CUSTOMER GSTIN"),
                  PAN: getCol(val, "CUSTOMER PAN"),
                  OPENBAL: getCol(val, "OPENING BALANCE") || "0",
                  PREV_FY: getCol(val, "CUSTOMER TURNOVER").toUpperCase() === "YES" ? "1" : "0",
                  EST_SALE: getCol(val, "EST. SALE / YEAR").toUpperCase().includes("> 50") ? "1" : "0",
                  DOM: domVal === "YES" ? "1" : "0",
                  COM: comVal === "YES" ? "1" : "0",
                  ARB: getCol(val, "ARB").toUpperCase() === "YES" ? "1" : "0",
                  PAYMENT_TERMS: paymentTerms,
                  SAMETYPE: (getCol(val, "SHIPPING ADDRESS SAME AS BILLING ADDRESS") || getCol(val, "SAME TYPE")).toUpperCase() === "YES" ? "1" : "2",
                };
              });
            if (parsedCust.length > 0) {
              setCustVendData(parsedCust);
              loadedInfo.push(`Customer (${parsedCust.length} rows)`);
            }
          }
        }

        // ── Parse Vendor sheet ──
        const vendorSheetName = workbook.SheetNames.find((n) => n.trim().toUpperCase() === "VENDOR");
        if (vendorSheetName) {
          const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(workbook.Sheets[vendorSheetName], { defval: "" }));
          if (jsonData.length > 0) {
            const getCol = makeGetCol(jsonData);
            parsedVend = jsonData
              .filter((val) => getCol(val, "VENDOR TRADE NAME"))
              .map((val) => {
                const gstReg = getCol(val, "GST REGISTRATION").toUpperCase();
                const domVal = getCol(val, "DOMESTIC CYL").toUpperCase();
                const comVal = (getCol(val, "COMERCIAL CYL") || getCol(val, "COMMERCIAL CYL")).toUpperCase();
                return {
                  CNAME: getCol(val, "VENDOR TRADE NAME"),
                  EMAIL: getCol(val, "EMAIL ID"),
                  ADDRESS1: getCol(val, "ADDRESS"),
                  DISTRICT1: getCol(val, "DISTRICT"),
                  LOCATION1: getCol(val, "LOCATION"),
                  PINCODE1: getCol(val, "PIN CODE"),
                  CONTACT: getCol(val, "MOBILE NO"),
                  STATE1: resolveStateCode(
                    getCol(val, "STATE") || getCol(val, "STATES")
                  ),
                  CTYPE: "0",
                  GST_REG: gstReg === "YES" ? "1" : "2",
                  GSTIN: getCol(val, "VENDOR GSTIN"),
                  PAN: getCol(val, "VENDOR PAN"),
                  OPENBAL: getCol(val, "OPENING BALANCE") || "0",
                  PREV_FY: getCol(val, "VENDOR TURNOVER").toUpperCase() === "YES" ? "1" : "0",
                  EST_SALE: getCol(val, "EST. PURCHASE / YEAR").toUpperCase().includes("> 50") ? "1" : "0",
                  DOM: domVal === "YES" ? "1" : "0",
                  COM: comVal === "YES" ? "1" : "0",
                  ARB: getCol(val, "ARB").toUpperCase() === "YES" ? "1" : "0",
                  PAYMENT_TERMS: gstReg === "YES" ? "1" : "0",
                  SAMETYPE: getCol(val, "SHIPPING ADDRESS SAME AS BILLING ADDRESS").toUpperCase() === "YES" ? "1" : "2",
                };
              });
            if (parsedVend.length > 0) {
              setVendData(parsedVend);
              loadedInfo.push(`Vendor (${parsedVend.length} rows)`);
            }
          }
        }

        // ── Parse OMC Plant sheet ──
        const omcSheetName = workbook.SheetNames.find((n) => n.trim().toUpperCase() === "OMC PLANT");
        if (omcSheetName) {
          const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(workbook.Sheets[omcSheetName], { defval: "" }));
          if (jsonData.length > 0) {
            const getCol = makeGetCol(jsonData);
            parsedOmc = jsonData
              .filter((val) => getCol(val, "OMC TRADE NAME"))
              .map((val) => {
                const domVal = getCol(val, "DOMESTIC CYL").toUpperCase();
                const comVal = (getCol(val, "COMERCIAL CYL") || getCol(val, "COMMERCIAL CYL")).toUpperCase();
                return {
                  CNAME: getCol(val, "OMC TRADE NAME"),
                  EMAIL: getCol(val, "EMAIL ID"),
                  ADDRESS1: getCol(val, "ADDRESS"),
                  DISTRICT1: getCol(val, "DISTRICT"),
                  LOCATION1: getCol(val, "LOCATION"),
                  PINCODE1: getCol(val, "PIN CODE"),
                  CONTACT: getCol(val, "MOBILE NO"),
                  STATE1: resolveStateCode(
                    getCol(val, "STATE") || getCol(val, "STATES")
                  ),
                  CTYPE: "2",
                  GST_REG: "1",
                  GSTIN: getCol(val, "OMC GSTIN"),
                  PAN: getCol(val, "OMC PAN"),
                  OPENBAL: getCol(val, "OPENING BALANCE") || "0",
                  PREV_FY: "1",
                  EST_SALE: getCol(val, "EST. PURCHASE / YEAR").toUpperCase().includes("> 50") ? "1" : "0",
                  DOM: domVal === "YES" ? "1" : "0",
                  COM: comVal === "YES" ? "1" : "0",
                  ARB: getCol(val, "ARB").toUpperCase() === "YES" ? "1" : "0",
                  PAYMENT_TERMS: "1",
                  SAMETYPE: getCol(val, "SHIPPING ADDRESS SAME AS BILLING ADDRESS").toUpperCase() === "YES" ? "1" : "2",
                };
              });
            if (parsedOmc.length > 0) {
              setOmcData(parsedOmc);
              loadedInfo.push(`OMC (${parsedOmc.length} rows)`);
            }
          }
        }

        // ── Parse Others sheet ──
        const othersSheetName = workbook.SheetNames.find((n) => n.trim().toUpperCase() === "OTHERS");
        if (othersSheetName) {
          const jsonData = normalizeKeys(XLSX.utils.sheet_to_json(workbook.Sheets[othersSheetName], { defval: "" }));
          if (jsonData.length > 0) {
            const getCol = makeGetCol(jsonData);
            parsedOth = jsonData
              .filter((val) => getCol(val, "OTHERS TRADE NAME"))
              .map((val) => {
                const gstReg = getCol(val, "GST REGISTRATION").toUpperCase();
                const domVal = getCol(val, "DOMESTIC CYL").toUpperCase();
                const comVal = (getCol(val, "COMERCIAL CYL") || getCol(val, "COMMERCIAL CYL")).toUpperCase();
                return {
                  CNAME: getCol(val, "OTHERS TRADE NAME"),
                  EMAIL: getCol(val, "EMAIL ID"),
                  ADDRESS1: getCol(val, "ADDRESS"),
                  DISTRICT1: getCol(val, "DISTRICT"),
                  LOCATION1: getCol(val, "LOCATION"),
                  PINCODE1: getCol(val, "PIN CODE"),
                  CONTACT: getCol(val, "MOBILE NO"),
                  STATE1: resolveStateCode(
                    getCol(val, "STATE") || getCol(val, "STATES")
                  ),
                  CTYPE: "3",
                  GST_REG: gstReg === "YES" ? "1" : "2",
                  GSTIN: getCol(val, "OTHERS GSTIN"),
                  PAN: getCol(val, "OTHERS PAN"),
                  OPENBAL: getCol(val, "OPENING BALANCE") || "0",
                  PREV_FY: getCol(val, "VENDOR TURNOVER").toUpperCase() === "YES" ? "1" : "0",
                  EST_SALE: getCol(val, "EST. PURCHASE / YEAR").toUpperCase().includes("> 50") ? "1" : "0",
                  DOM: domVal === "YES" ? "1" : "0",
                  COM: comVal === "YES" ? "1" : "0",
                  ARB: getCol(val, "ARB").toUpperCase() === "YES" ? "1" : "0",
                  PAYMENT_TERMS: gstReg === "YES" ? "1" : "0",
                  SAMETYPE: getCol(val, "SHIPPING ADDRESS SAME AS BILLING ADDRESS").toUpperCase() === "YES" ? "1" : "2",
                };
              });
            if (parsedOth.length > 0) {
              setOthersData(parsedOth);
              loadedInfo.push(`Others (${parsedOth.length} rows)`);
            }
          }
        }

        if (!loadedInfo.length) {
          setOpen(true);
          setMess("No data rows found in Customer, Vendor, OMC Plant, or Others sheets.");
          return;
        }
        toast.success(`Loaded: ${loadedInfo.join(", ")}`);

        // Verify pincodes — await so submit stays disabled until done
        await verifyCustVendPincodes(parsedCust, parsedVend, parsedOmc, parsedOth);

      } catch (err) {
        setPincodeVerifying(false);
        setOpen(true);
        setMess("Invalid Excel file format.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  const getStateName = (stateCode) => {
    const st = (stateList || []).find((s) => String(s?.code) === String(stateCode));
    return st ? st.name : stateCode || "-";
  };

  // Verify pincode+state for all rows, then check location matches API locations
  const verifyCustVendPincodes = async (customers, vendors, omcs, others) => {
    setPincodeVerifying(true);

    // Re-resolve state code in case stateList wasn't loaded during Excel parse
    const resolveState = (val) => {
      const v = String(val || "").trim();
      if (!v) return "";
      // Already a numeric code
      if (/^\d+$/.test(v)) return v;
      // Try to find by name
      const found = (stateList || []).find(
        (s) => String(s?.name || "").toUpperCase() === v.toUpperCase()
      );
      return found ? String(found.code) : v;
    };

    const verifyRows = async (rows) => {
      const results = [];
      for (const row of rows) {
        const pincode = String(row.PINCODE1 || "").trim();
        const stateCode = resolveState(row.STATE1);
        const userLocation = String(row.LOCATION1 || "").trim();
        if (pincode.length === 6 && stateCode) {
          try {
            const body = new FormData();
            body.append("pincode", pincode);
            body.append("state", stateCode);
            const res = await pincode_verify_api(body);
            const locations = res?.locations || [];
            if (res?.success) {
              // Pincode+state match — now check if user location matches API locations
              if (userLocation && locations.length > 0) {
                const match = locations.some(
                  (loc) => String(loc).trim().toUpperCase() === userLocation.toUpperCase()
                );
                if (!match) {
                  results.push({
                    ...row, LOCATION_OPTIONS: locations,
                    PINCODE_ERR: "", LOCATION_ERR: "Location doesn't match. Select correct location.",
                  });
                } else {
                  results.push({ ...row, LOCATION_OPTIONS: locations, PINCODE_ERR: "", LOCATION_ERR: "" });
                }
              } else if (!userLocation && locations.length > 0) {
                results.push({
                  ...row, LOCATION_OPTIONS: locations,
                  PINCODE_ERR: "", LOCATION_ERR: "Please select a location.",
                });
              } else {
                results.push({ ...row, LOCATION_OPTIONS: locations, PINCODE_ERR: "", LOCATION_ERR: "" });
              }
            } else {
              // Pincode+state mismatch — user must fix state in Excel and re-upload
              results.push({
                ...row, LOCATION_OPTIONS: [],
                PINCODE_ERR: res?.message || "Pin Code doesn't match to state",
                LOCATION_ERR: "",
              });
            }
          } catch {
            results.push({ ...row, LOCATION_OPTIONS: [], PINCODE_ERR: "", LOCATION_ERR: "" });
          }
        } else {
          results.push({ ...row, LOCATION_OPTIONS: [], PINCODE_ERR: "", LOCATION_ERR: "" });
        }
      }
      return results;
    };

    try {
      toast.info("Verifying pincodes...");
      const [c, v, o, ot] = await Promise.all([
        customers.length ? verifyRows(customers) : Promise.resolve([]),
        vendors.length ? verifyRows(vendors) : Promise.resolve([]),
        omcs.length ? verifyRows(omcs) : Promise.resolve([]),
        others.length ? verifyRows(others) : Promise.resolve([]),
      ]);

      if (c.length) setCustVendData(c);
      if (v.length) setVendData(v);
      if (o.length) setOmcData(o);
      if (ot.length) setOthersData(ot);

      const allRows = [...c, ...v, ...o, ...ot];
      const pinErr = allRows.filter((r) => r.PINCODE_ERR).length;
      const locErr = allRows.filter((r) => r.LOCATION_ERR).length;
      if (pinErr > 0) {
        toast.error(`${pinErr} row(s) have pincode/state mismatch. Fix state in Excel and re-upload.`);
      }
      if (locErr > 0) {
        toast.warn(`${locErr} row(s) have location mismatch. Select correct location from dropdown.`);
      }
      if (pinErr === 0 && locErr === 0) {
        toast.success("All pincodes verified successfully.");
      }
    } finally {
      setPincodeVerifying(false);
    }
  };

  const validateCustVendData = () => {
    const errors = [];
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (custVendData.length > 0) {
      const emails = [];
      custVendData.forEach((row, index) => {
        const rowNo = index + 1;
        if (!row.CNAME) errors.push(`Customer Row ${rowNo}: Customer Trade Name is required`);
        if (!row.EMAIL) {
          errors.push(`Customer Row ${rowNo}: Email ID is required`);
        } else if (!emailRegex.test(row.EMAIL)) {
          errors.push(`Customer Row ${rowNo}: Invalid Email ID format`);
        } else {
          emails.push(row.EMAIL);
        }
        if (!row.ADDRESS1) errors.push(`Customer Row ${rowNo}: Billing Address is required`);
        if (!row.PINCODE1) {
          errors.push(`Customer Row ${rowNo}: PIN Code is required`);
        } else if (!/^\d{6}$/.test(row.PINCODE1)) {
          errors.push(`Customer Row ${rowNo}: PIN Code must be exactly 6 digits`);
        }
        if (row.PINCODE_ERR) errors.push(`Customer Row ${rowNo}: ${row.PINCODE_ERR}`);
        if (row.LOCATION_ERR) errors.push(`Customer Row ${rowNo}: ${row.LOCATION_ERR}`);
        if (!row.CONTACT) {
          errors.push(`Customer Row ${rowNo}: Mobile No is required`);
        } else if (!/^\d{10}$/.test(row.CONTACT)) {
          errors.push(`Customer Row ${rowNo}: Mobile No must be exactly 10 digits`);
        }
        if (row.GST_REG === "1" && row.GSTIN && !gstinRegex.test(row.GSTIN))
          errors.push(`Customer Row ${rowNo}: Invalid GSTIN format`);
        if (row.PAN && row.PAN !== "NA" && !panRegex.test(row.PAN))
          errors.push(`Customer Row ${rowNo}: Invalid PAN format (e.g. ABCDE1234F)`);
        if (row.DOM === "0" && row.COM === "0" && row.ARB === "0")
          errors.push(`Customer Row ${rowNo}: At least one product (DOM/COM/ARB) must be YES`);
      });
      if (new Set(emails).size !== emails.length)
        errors.push("Customer: Duplicate Email IDs are not allowed.");
    }
    if (vendData.length > 0) {
      const emails = [];
      vendData.forEach((row, index) => {
        const rowNo = index + 1;
        if (!row.CNAME) errors.push(`Vendor Row ${rowNo}: Vendor Trade Name is required`);
        if (!row.EMAIL) {
          errors.push(`Vendor Row ${rowNo}: Email ID is required`);
        } else if (!emailRegex.test(row.EMAIL)) {
          errors.push(`Vendor Row ${rowNo}: Invalid Email ID format`);
        } else {
          emails.push(row.EMAIL);
        }
        if (!row.ADDRESS1) errors.push(`Vendor Row ${rowNo}: Address is required`);
        if (!row.PINCODE1) {
          errors.push(`Vendor Row ${rowNo}: PIN Code is required`);
        } else if (!/^\d{6}$/.test(row.PINCODE1)) {
          errors.push(`Vendor Row ${rowNo}: PIN Code must be exactly 6 digits`);
        }
        if (row.PINCODE_ERR) errors.push(`Vendor Row ${rowNo}: ${row.PINCODE_ERR}`);
        if (row.LOCATION_ERR) errors.push(`Vendor Row ${rowNo}: ${row.LOCATION_ERR}`);
        if (!row.CONTACT) {
          errors.push(`Vendor Row ${rowNo}: Mobile No is required`);
        } else if (!/^\d{10}$/.test(row.CONTACT)) {
          errors.push(`Vendor Row ${rowNo}: Mobile No must be exactly 10 digits`);
        }
        if (row.GST_REG === "1" && row.GSTIN && !gstinRegex.test(row.GSTIN))
          errors.push(`Vendor Row ${rowNo}: Invalid GSTIN format`);
        if (row.PAN && row.PAN !== "NA" && !panRegex.test(row.PAN))
          errors.push(`Vendor Row ${rowNo}: Invalid PAN format (e.g. ABCDE1234F)`);
        if (row.DOM === "0" && row.COM === "0" && row.ARB === "0")
          errors.push(`Vendor Row ${rowNo}: At least one product (DOM/COM/ARB) must be YES`);
      });
      if (new Set(emails).size !== emails.length)
        errors.push("Vendor: Duplicate Email IDs are not allowed.");
    }
    if (omcData.length > 0) {
      const emails = [];
      omcData.forEach((row, index) => {
        const rowNo = index + 1;
        if (!row.CNAME) errors.push(`OMC Row ${rowNo}: OMC Trade Name is required`);
        if (!row.EMAIL) {
          errors.push(`OMC Row ${rowNo}: Email ID is required`);
        } else if (!emailRegex.test(row.EMAIL)) {
          errors.push(`OMC Row ${rowNo}: Invalid Email ID format`);
        } else {
          emails.push(row.EMAIL);
        }
        if (!row.ADDRESS1) errors.push(`OMC Row ${rowNo}: Address is required`);
        if (!row.PINCODE1) {
          errors.push(`OMC Row ${rowNo}: PIN Code is required`);
        } else if (!/^\d{6}$/.test(row.PINCODE1)) {
          errors.push(`OMC Row ${rowNo}: PIN Code must be exactly 6 digits`);
        }
        if (row.PINCODE_ERR) errors.push(`OMC Row ${rowNo}: ${row.PINCODE_ERR}`);
        if (row.LOCATION_ERR) errors.push(`OMC Row ${rowNo}: ${row.LOCATION_ERR}`);
        if (!row.CONTACT) {
          errors.push(`OMC Row ${rowNo}: Mobile No is required`);
        } else if (!/^\d{10}$/.test(row.CONTACT)) {
          errors.push(`OMC Row ${rowNo}: Mobile No must be exactly 10 digits`);
        }
        if (row.GSTIN && !gstinRegex.test(row.GSTIN))
          errors.push(`OMC Row ${rowNo}: Invalid GSTIN format`);
        if (row.PAN && row.PAN !== "NA" && !panRegex.test(row.PAN))
          errors.push(`OMC Row ${rowNo}: Invalid PAN format (e.g. ABCDE1234F)`);
        if (row.DOM === "0" && row.COM === "0" && row.ARB === "0")
          errors.push(`OMC Row ${rowNo}: At least one product (DOM/COM/ARB) must be YES`);
      });
      if (new Set(emails).size !== emails.length)
        errors.push("OMC: Duplicate Email IDs are not allowed.");
    }
    if (othersData.length > 0) {
      const emails = [];
      othersData.forEach((row, index) => {
        const rowNo = index + 1;
        if (!row.CNAME) errors.push(`Others Row ${rowNo}: Trade Name is required`);
        if (!row.EMAIL) {
          errors.push(`Others Row ${rowNo}: Email ID is required`);
        } else if (!emailRegex.test(row.EMAIL)) {
          errors.push(`Others Row ${rowNo}: Invalid Email ID format`);
        } else {
          emails.push(row.EMAIL);
        }
        if (!row.ADDRESS1) errors.push(`Others Row ${rowNo}: Address is required`);
        if (!row.PINCODE1) {
          errors.push(`Others Row ${rowNo}: PIN Code is required`);
        } else if (!/^\d{6}$/.test(row.PINCODE1)) {
          errors.push(`Others Row ${rowNo}: PIN Code must be exactly 6 digits`);
        }
        if (row.PINCODE_ERR) errors.push(`Others Row ${rowNo}: ${row.PINCODE_ERR}`);
        if (row.LOCATION_ERR) errors.push(`Others Row ${rowNo}: ${row.LOCATION_ERR}`);
        if (!row.CONTACT) {
          errors.push(`Others Row ${rowNo}: Mobile No is required`);
        } else if (!/^\d{10}$/.test(row.CONTACT)) {
          errors.push(`Others Row ${rowNo}: Mobile No must be exactly 10 digits`);
        }
        if (row.GST_REG === "1" && row.GSTIN && !gstinRegex.test(row.GSTIN))
          errors.push(`Others Row ${rowNo}: Invalid GSTIN format`);
        if (row.PAN && row.PAN !== "NA" && !panRegex.test(row.PAN))
          errors.push(`Others Row ${rowNo}: Invalid PAN format (e.g. ABCDE1234F)`);
        if (row.DOM === "0" && row.COM === "0" && row.ARB === "0")
          errors.push(`Others Row ${rowNo}: At least one product (DOM/COM/ARB) must be YES`);
      });
      if (new Set(emails).size !== emails.length)
        errors.push("Others: Duplicate Email IDs are not allowed.");
    }
    return errors;
  };

  const handleCustVendSubmit = async () => {
    if (!custVendData.length && !vendData.length && !omcData.length && !othersData.length) {
      toast.error("Please upload Excel first.");
      return;
    }
    const validationErrors = validateCustVendData();
    if (validationErrors.length > 0) {
      setOpen(true);
      setMess(<Alerts data={validationErrors} />);
      return;
    }
    const appendItems = (body, items) => {
      items.forEach((item) => {
        body.append("email[]", item.EMAIL);
        body.append("cname[]", item.CNAME);
        body.append("address1[]", item.ADDRESS1);
        body.append("state1[]", item.STATE1 || "");
        body.append("district1[]", item.DISTRICT1);
        body.append("location1[]", item.LOCATION1);
        body.append("pincode1[]", item.PINCODE1);
        body.append("contact[]", item.CONTACT);
        body.append("ctype[]", item.CTYPE);
        body.append("gstreg[]", item.GST_REG);
        body.append("gstin[]", item.GSTIN);
        body.append("pan[]", item.PAN);
        body.append("openbal[]", item.OPENBAL);
        body.append("previous_fy_turnover[]", item.PREV_FY);
        body.append("estimated_sales_value[]", item.EST_SALE);
        body.append("dom[]", item.DOM);
        body.append("com[]", item.COM);
        body.append("arb[]", item.ARB);
        body.append("sametype[]", item.SAMETYPE);
        body.append(
          "payment_terms[]",
          item.CTYPE === "1" ? (item.PAYMENT_TERMS || "1") : "0"
        );
      });
    };
    try {
      setCustVendLoading(true);
      if (custVendData.length > 0) {
        const body = new FormData();
        body.append("action", "email_verification_excel");
        body.append("agencyid", user_id);
        appendItems(body, custVendData);
        if (emp_id) body.append("emp_code", emp_id);
        const { data } = await axios.post(base_url + "vend_master_api.php", body);
        if (data.success) {
          setCustVendData([]);
        } else {
          setOpen(true);
          setMess(data.message);
          setCustVendLoading(false);
          return;
        }
      }
      if (vendData.length > 0) {
        const body = new FormData();
        body.append("action", "email_verification_excel");
        body.append("agencyid", user_id);
        appendItems(body, vendData);
        if (emp_id) body.append("emp_code", emp_id);
        const { data } = await axios.post(base_url + "vend_master_api.php", body);
        if (data.success) {
          setVendData([]);
        } else {
          setOpen(true);
          setMess(data.message);
          setCustVendLoading(false);
          return;
        }
      }
      if (omcData.length > 0) {
        const body = new FormData();
        body.append("action", "email_verification_excel");
        body.append("agencyid", user_id);
        appendItems(body, omcData);
        if (emp_id) body.append("emp_code", emp_id);
        const { data } = await axios.post(base_url + "vend_master_api.php", body);
        if (data.success) {
          setOmcData([]);
        } else {
          setOpen(true);
          setMess(data.message);
          setCustVendLoading(false);
          return;
        }
      }
      if (othersData.length > 0) {
        const body = new FormData();
        body.append("action", "email_verification_excel");
        body.append("agencyid", user_id);
        appendItems(body, othersData);
        if (emp_id) body.append("emp_code", emp_id);
        const { data } = await axios.post(base_url + "vend_master_api.php", body);
        if (data.success) {
          setOthersData([]);
        } else {
          setOpen(true);
          setMess(data.message);
          setCustVendLoading(false);
          return;
        }
      }
      setCustVendLoading(false);
      toast.success("All data submitted successfully");
    } catch (err) {
      setCustVendLoading(false);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <SmallModal
        isOpen={isFTL}
        setIsOpen={setIsFTL}
        style={{ minWidth: "50rem" }}
        okbtn={true}
        okBtnHide={false}
        onClick={() => setIsFTL(false)}
        title="MASTER DATA EXCEL UPLOAD"
        header_right={<></>}
        mess={
          <div style={{ margin: "2rem 0" }}>
            {/* ── EQUIPMENT / ARB MASTER ── */}
            <div style={{ display: "flex", gap: 20 }}>
              <div style={{ flex: 1, display: "flex", textAlign: "start" }}>
                EQUIPMENT / ARB MASTER EXCEL
              </div>
              <Button
                onClick={handleCombinedEquipArbDownload}
                title="DOWNLOAD TEMPLATE"
              />
              <Button onClick={() => combinedEquipArbFileInputRef.current.click()} title="UPLOAD EXCEL" />
              <input
                type="file"
                accept=".xlsx, .xls"
                ref={combinedEquipArbFileInputRef}
                style={{ display: "none" }}
                onChange={handleCombinedEquipArbFileChange}
              />
            </div>
            {excelData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Equipment Data ({excelData.length} rows)</h4>
                  <button
                    onClick={() => setExcelData([])}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#dc3545",
                      padding: "5px 10px",
                    }}
                    title="Clear Equipment Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={excelData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={excelData?.length == 0 ? true : false}
                  headData={[
                    "EQUIPMENT",
                    "UNITS",
                    "GST %",
                    "HSN CODE",
                    "SECURITY DEPOSIT",
                    "OPENING FULLS",
                    "OPENING EMPTIES",
                    "EFFECTIVE DATE",
                    "GODOWN NAME",
                  ]}
                  body={excelData.map((v, i) => (
                    <tr key={i}>
                      <td>{`${v?.CAT_NAME || ""} ${v?.CAT_DESC || ""}`.trim() || "-"}</td>
                      <td>{v?.UNITS == 1 ? "NOS" : "KGS"}</td>
                      <td>{v?.GSTP}</td>
                      <td>{v?.CSTEH_NO}</td>
                      <td>{v?.SECURITY_DEPOSIT}</td>
                      <td>{v?.OS_FULLS}</td>
                      <td>{v?.OS_EMPTYS}</td>
                      <td>{v?.EFFECTIVE_DATE}</td>
                      <td>{v?.GODOWN_NAME || v?.GODOWN_ID || "-"}</td>
                    </tr>
                  ))}
                />
              </>
            )}

            {arbData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>ARB Data ({arbData.length} rows)</h4>
                  <button
                    onClick={() => setArbData([])}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#dc3545",
                      padding: "5px 10px",
                    }}
                    title="Clear ARB Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={arbData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={arbData?.length == 0 ? true : false}
                  headData={[
                    "CATEGORY",
                    "SUB-CATEGORY",
                    "BRAND NAME",
                    "PRODUCT DESC.",
                    "HSN/SAC CODE",
                    "UoM",
                    "GST RATE",
                    "OPENING STOCK",
                    "PURCHASE PRICE",
                    "EFFECTIVE DATE",
                  ]}
                  body={arbData.map((v, i) => (
                    <tr key={i}>
                      <td>{v?.CATEGORY || "-"}</td>
                      <td>{v?.SUB_CATEGORY || "-"}</td>
                      <td>{v?.BRAND || "-"}</td>
                      <td>{v?.PRODUCT_NAME || "-"}</td>
                      <td>{v?.HSN_CODE || "-"}</td>
                      <td>{v?.UNIT == 1 ? "NOS" : v?.UNIT == 2 ? "KGS" : "-"}</td>
                      <td>{v?.GST}</td>
                      <td>{v?.OPENING_STOCK}</td>
                      <td>{v?.PRICE}</td>
                      <td>{v?.EFFECTIVE_DATE}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {(excelData?.length > 0 || arbData?.length > 0) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "2%",
                }}
              >
                <Button
                  onClick={handleCombinedEquipArbSubmit}
                  title={combinedEquipArbLoading ? "Uploading..." : "SUBMIT ALL DATA"}
                  disable={combinedEquipArbLoading}
                />
              </div>
            )}

            {/* ── STAFF / VEHICLE / AREA CODE / ALERT MASTER ── */}
            <div style={{ display: "flex", gap: 20, marginTop: 10 }}>
              <div style={{ flex: 1, display: "flex", textAlign: "start" }}>
                STAFF / VEHICLE / AREA CODE / ALERT MASTER EXCEL
              </div>
              <Button
                onClick={handleCombinedAdminDownload}
                title="DOWNLOAD TEMPLATE"
              />
              <Button
                onClick={async () => {
                  if (!alertItemList.length) {
                    await fetchAlertItemList();
                  }
                  combinedAdminFileInputRef.current.click();
                }}
                title="UPLOAD EXCEL"
              />
              <input
                type="file"
                accept=".xlsx, .xls"
                ref={combinedAdminFileInputRef}
                style={{ display: "none" }}
                onChange={handleCombinedAdminFileChange}
              />
            </div>
            {staffData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Staff Data ({staffData.length} rows)</h4>
                  <button
                    onClick={() => setStaffData([])}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#dc3545",
                      padding: "5px 10px",
                    }}
                    title="Clear Staff Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={staffData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={staffData?.length == 0 ? true : false}
                  headData={[
                    "EMP CODE",
                    "EMP NAME",
                    "DATE OF BIRTH",
                    "DESIGNATION",
                    "ROLE",
                    "JOINING DATE",
                  ]}
                  body={staffData.map((v, i) => (
                    <tr key={i}>
                      <td>{v?.EMP_CODE}</td>
                      <td>{v?.EMP_NAME}</td>
                      <td>{moment(v?.DOB).format("DD-MM-YYYY")}</td>
                      <td>{v?.DESIGNATION}</td>
                      <td>{v?.ROLE_NAME || staffOptions.find((o) => o.value === String(v?.ROLE))?.label || v?.ROLE}</td>
                      <td>{moment(v?.JOINING_DATE).format("DD-MM-YYYY")}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {vehicleData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Vehicle Data ({vehicleData.length} rows)</h4>
                  <button
                    onClick={() => setVehicleData([])}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#dc3545",
                      padding: "5px 10px",
                    }}
                    title="Clear Vehicle Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={vehicleData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={vehicleData?.length == 0 ? true : false}
                  headData={[
                    "VEHICLE NUMBER",
                    "VEHICLE MAKE",
                    "VEHICLE TYPE",
                    "VEHICLE USAGE",
                  ]}
                  body={vehicleData.map((v, i) => (
                    <tr key={i}>
                      <td>{v?.VEHICLE_NUMBER}</td>
                      <td>{v?.VEHICLE_MAKE}</td>
                      <td>{v?.VEHICLE_TYPE_NAME || vehicleTypeNames[v?.VEHICLE_TYPE] || v?.VEHICLE_TYPE}</td>
                      <td>{v?.VEHICLE_USAGE_NAME || vehicleUsageNames[v?.VEHICLE_USAGE] || v?.VEHICLE_USAGE}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {areaCodeData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Area Code Data ({areaCodeData.length} rows)</h4>
                  <button
                    onClick={() => setAreaCodeData([])}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#dc3545",
                      padding: "5px 10px",
                    }}
                    title="Clear Area Code Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={areaCodeData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={areaCodeData?.length == 0 ? true : false}
                  headData={[
                    "PINCODE",
                    "AREA CODE",
                    "AREA NAME",
                    "ONEWAY DISTANCE",
                    "TRANSPORT CHARGE",
                    "EFFECTIVE DATE",
                  ]}
                  body={areaCodeData.map((v, i) => (
                    <tr key={i}>
                      <td>{v?.PINCODE}</td>
                      <td>{v?.AREA_CODE}</td>
                      <td>{v?.AREA_NAME}</td>
                      <td>{v?.DISTANCE}</td>
                      <td>{v?.CHARGE}</td>
                      <td>{v?.EFFECTIVE_DATE}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {alertData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Alert Data ({alertData.length} rows)</h4>
                  <button
                    onClick={() => setAlertData([])}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#dc3545",
                      padding: "5px 10px",
                    }}
                    title="Clear Alert Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={alertData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={alertData?.length == 0 ? true : false}
                  headData={[
                    "ITEM",
                    "REFERENCE NO",
                    "VALID UPTO",
                    "REMINDER",
                    "REMARKS",
                  ]}
                  body={alertData.map((v, i) => (
                    <tr key={i}>
                      <td>{v?.ITEM_NAME}</td>
                      <td>{v?.REFERENCE_NO}</td>
                      <td>{v?.VALID_UPTO}</td>
                      <td>{reminderOptions.find((o) => o.value === String(v?.REMINDER))?.label || v?.REMINDER_NAME}</td>
                      <td>{v?.REMARKS}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {(staffData?.length > 0 || vehicleData?.length > 0 || areaCodeData?.length > 0 || alertData?.length > 0) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "2%",
                }}
              >
                <Button
                  onClick={handleCombinedAdminSubmit}
                  title={combinedAdminLoading ? "Uploading..." : "SUBMIT ALL DATA"}
                  disable={combinedAdminLoading}
                />
              </div>
            )}
            {/* ── CUSTOMER / VENDOR / OTHERS MASTER ── */}
            <div style={{ display: "flex", gap: 20, marginTop: 10 }}>
              <div style={{ flex: 1, display: "flex", textAlign: "start" }}>
                CUSTOMER / VENDOR / OMC / OTHERS MASTER EXCEL
              </div>
              <Button onClick={handleCustVendDownload} title="DOWNLOAD TEMPLATE" />
              <Button onClick={() => custVendFileInputRef.current.click()} title="UPLOAD EXCEL" />
              <input
                type="file"
                accept=".xlsx, .xls"
                ref={custVendFileInputRef}
                style={{ display: "none" }}
                onChange={handleCustVendFileChange}
              />
            </div>
            {custVendData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Customer Data ({custVendData.length} rows)</h4>
                  <button
                    onClick={() => setCustVendData([])}
                    style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: "20px", color: "#dc3545", padding: "5px 10px" }}
                    title="Clear Customer Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={custVendData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={custVendData?.length === 0}
                  headData={["CUSTOMER NAME", "EMAIL ID", "BILLING ADDRESS", "STATE", "LOCATION", "PIN CODE", "MOBILE NO", "GST REG", "GSTIN", "PAN", "OPENING BAL", "TURNOVER", "EST. SALE", "DOM", "COM", "ARB", "PREFERRED PAYMENT METHOD", "SAME ADDRESS"]}
                  body={custVendData.map((v, i) => (
                    <tr key={i} style={v?.PINCODE_ERR || v?.LOCATION_ERR ? { background: "#fff3cd" } : {}}>
                      <td>{v?.CNAME || "-"}</td>
                      <td>{v?.EMAIL || "-"}</td>
                      <td>{v?.ADDRESS1 || "-"}</td>
                      <td style={v?.PINCODE_ERR ? { color: "#dc3545", fontWeight: "bold" } : {}}>
                        {getStateName(v?.STATE1)}
                        {v?.PINCODE_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.PINCODE_ERR}</div>}
                      </td>
                      <td>
                        {v?.LOCATION_ERR && v?.LOCATION_OPTIONS?.length > 0 ? (
                          <select
                            value={v?.LOCATION1 || ""}
                            onChange={(e) => {
                              const updated = [...custVendData];
                              updated[i] = { ...updated[i], LOCATION1: e.target.value, LOCATION_ERR: "" };
                              setCustVendData(updated);
                            }}
                            style={{ border: "1px solid #dc3545", padding: "2px 4px", borderRadius: 4, minWidth: 120 }}
                          >
                            <option value="">-- Select Location --</option>
                            {v.LOCATION_OPTIONS.map((loc, li) => (
                              <option key={li} value={loc}>{loc}</option>
                            ))}
                          </select>
                        ) : (
                          v?.LOCATION1 || "-"
                        )}
                        {v?.LOCATION_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.LOCATION_ERR}</div>}
                      </td>
                      <td>{v?.PINCODE1 || "-"}</td>
                      <td>{v?.CONTACT || "-"}</td>
                      <td>{v?.GST_REG === "1" ? "YES" : "NO"}</td>
                      <td>{v?.GSTIN || "-"}</td>
                      <td>{v?.PAN || "-"}</td>
                      <td>{v?.OPENBAL}</td>
                      <td>{v?.PREV_FY === "1" ? "YES" : (v?.PREV_FY === "0" ? "NO" : v?.PREV_FY)}</td>
                      <td>{v?.EST_SALE === "1" ? "> 50 Lakhs" : (v?.EST_SALE === "0" ? "< 50 Lakhs" : v?.EST_SALE)}</td>
                      <td>{v?.DOM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.COM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.ARB === "1" ? "YES" : "NO"}</td>
                      <td>{v?.CTYPE === "1" ? (v?.PAYMENT_TERMS === "2" ? "Credit" : "Cash") : "NA"}</td>
                      <td>{v?.SAMETYPE === "1" ? "YES" : "NO"}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {vendData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Vendor Data ({vendData.length} rows)</h4>
                  <button
                    onClick={() => setVendData([])}
                    style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: "20px", color: "#dc3545", padding: "5px 10px" }}
                    title="Clear Vendor Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={vendData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={vendData?.length === 0}
                  headData={["VENDOR NAME", "EMAIL ID", "ADDRESS", "STATE", "LOCATION", "PIN CODE", "MOBILE NO", "GST REG", "GSTIN", "PAN", "OPENING BAL", "TURNOVER", "EST. PURCHASE", "DOM", "COM", "ARB", "SAME ADDRESS"]}
                  body={vendData.map((v, i) => (
                    <tr key={i} style={v?.PINCODE_ERR || v?.LOCATION_ERR ? { background: "#fff3cd" } : {}}>
                      <td>{v?.CNAME || "-"}</td>
                      <td>{v?.EMAIL || "-"}</td>
                      <td>{v?.ADDRESS1 || "-"}</td>
                      <td style={v?.PINCODE_ERR ? { color: "#dc3545", fontWeight: "bold" } : {}}>
                        {getStateName(v?.STATE1)}
                        {v?.PINCODE_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.PINCODE_ERR}</div>}
                      </td>
                      <td>
                        {v?.LOCATION_ERR && v?.LOCATION_OPTIONS?.length > 0 ? (
                          <select
                            value={v?.LOCATION1 || ""}
                            onChange={(e) => {
                              const updated = [...vendData];
                              updated[i] = { ...updated[i], LOCATION1: e.target.value, LOCATION_ERR: "" };
                              setVendData(updated);
                            }}
                            style={{ border: "1px solid #dc3545", padding: "2px 4px", borderRadius: 4, minWidth: 120 }}
                          >
                            <option value="">-- Select Location --</option>
                            {v.LOCATION_OPTIONS.map((loc, li) => (
                              <option key={li} value={loc}>{loc}</option>
                            ))}
                          </select>
                        ) : (
                          v?.LOCATION1 || "-"
                        )}
                        {v?.LOCATION_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.LOCATION_ERR}</div>}
                      </td>
                      <td>{v?.PINCODE1 || "-"}</td>
                      <td>{v?.CONTACT || "-"}</td>
                      <td>{v?.GST_REG === "1" ? "YES" : "NO"}</td>
                      <td>{v?.GSTIN || "-"}</td>
                      <td>{v?.PAN || "-"}</td>
                      <td>{v?.OPENBAL}</td>
                      <td>{v?.PREV_FY}</td>
                      <td>{v?.EST_SALE}</td>
                      <td>{v?.DOM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.COM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.ARB === "1" ? "YES" : "NO"}</td>
                      <td>{v?.SAMETYPE === "1" ? "YES" : "NO"}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {omcData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>OMC Data ({omcData.length} rows)</h4>
                  <button
                    onClick={() => setOmcData([])}
                    style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: "20px", color: "#dc3545", padding: "5px 10px" }}
                    title="Clear OMC Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={omcData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={omcData?.length === 0}
                  headData={["OMC NAME", "EMAIL ID", "ADDRESS", "STATE", "LOCATION", "PIN CODE", "MOBILE NO", "GSTIN", "PAN", "OPENING BAL", "EST. PURCHASE", "DOM", "COM", "ARB", "SAME ADDRESS"]}
                  body={omcData.map((v, i) => (
                    <tr key={i} style={v?.PINCODE_ERR || v?.LOCATION_ERR ? { background: "#fff3cd" } : {}}>
                      <td>{v?.CNAME || "-"}</td>
                      <td>{v?.EMAIL || "-"}</td>
                      <td>{v?.ADDRESS1 || "-"}</td>
                      <td style={v?.PINCODE_ERR ? { color: "#dc3545", fontWeight: "bold" } : {}}>
                        {getStateName(v?.STATE1)}
                        {v?.PINCODE_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.PINCODE_ERR}</div>}
                      </td>
                      <td>
                        {v?.LOCATION_ERR && v?.LOCATION_OPTIONS?.length > 0 ? (
                          <select
                            value={v?.LOCATION1 || ""}
                            onChange={(e) => {
                              const updated = [...omcData];
                              updated[i] = { ...updated[i], LOCATION1: e.target.value, LOCATION_ERR: "" };
                              setOmcData(updated);
                            }}
                            style={{ border: "1px solid #dc3545", padding: "2px 4px", borderRadius: 4, minWidth: 120 }}
                          >
                            <option value="">-- Select Location --</option>
                            {v.LOCATION_OPTIONS.map((loc, li) => (
                              <option key={li} value={loc}>{loc}</option>
                            ))}
                          </select>
                        ) : (
                          v?.LOCATION1 || "-"
                        )}
                        {v?.LOCATION_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.LOCATION_ERR}</div>}
                      </td>
                      <td>{v?.PINCODE1 || "-"}</td>
                      <td>{v?.CONTACT || "-"}</td>
                      <td>{v?.GSTIN || "-"}</td>
                      <td>{v?.PAN || "-"}</td>
                      <td>{v?.OPENBAL}</td>
                      <td>{v?.EST_SALE}</td>
                      <td>{v?.DOM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.COM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.ARB === "1" ? "YES" : "NO"}</td>
                      <td>{v?.SAMETYPE === "1" ? "YES" : "NO"}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {othersData?.length > 0 && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                  <h4 style={{ margin: 0 }}>Others Data ({othersData.length} rows)</h4>
                  <button
                    onClick={() => setOthersData([])}
                    style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: "20px", color: "#dc3545", padding: "5px 10px" }}
                    title="Clear Others Data"
                  >
                    ✕
                  </button>
                </div>
                <TableNew
                  mt={10}
                  totalCount={othersData?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  entries={entries}
                  setEntries={setEntries}
                  setSearchInput={setSearchInput}
                  SerchInput={SerchInput}
                  nodata={othersData?.length === 0}
                  headData={["TRADE NAME", "EMAIL ID", "ADDRESS", "STATE", "LOCATION", "PIN CODE", "MOBILE NO", "GST REG", "GSTIN", "PAN", "OPENING BAL", "TURNOVER", "EST. PURCHASE", "DOM", "COM", "ARB", "SAME ADDRESS"]}
                  body={othersData.map((v, i) => (
                    <tr key={i} style={v?.PINCODE_ERR || v?.LOCATION_ERR ? { background: "#fff3cd" } : {}}>
                      <td>{v?.CNAME || "-"}</td>
                      <td>{v?.EMAIL || "-"}</td>
                      <td>{v?.ADDRESS1 || "-"}</td>
                      <td style={v?.PINCODE_ERR ? { color: "#dc3545", fontWeight: "bold" } : {}}>
                        {getStateName(v?.STATE1)}
                        {v?.PINCODE_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.PINCODE_ERR}</div>}
                      </td>
                      <td>
                        {v?.LOCATION_ERR && v?.LOCATION_OPTIONS?.length > 0 ? (
                          <select
                            value={v?.LOCATION1 || ""}
                            onChange={(e) => {
                              const updated = [...othersData];
                              updated[i] = { ...updated[i], LOCATION1: e.target.value, LOCATION_ERR: "" };
                              setOthersData(updated);
                            }}
                            style={{ border: "1px solid #dc3545", padding: "2px 4px", borderRadius: 4, minWidth: 120 }}
                          >
                            <option value="">-- Select Location --</option>
                            {v.LOCATION_OPTIONS.map((loc, li) => (
                              <option key={li} value={loc}>{loc}</option>
                            ))}
                          </select>
                        ) : (
                          v?.LOCATION1 || "-"
                        )}
                        {v?.LOCATION_ERR && <div style={{ fontSize: 10, color: "#dc3545" }}>{v.LOCATION_ERR}</div>}
                      </td>
                      <td>{v?.PINCODE1 || "-"}</td>
                      <td>{v?.CONTACT || "-"}</td>
                      <td>{v?.GST_REG === "1" ? "YES" : "NO"}</td>
                      <td>{v?.GSTIN || "-"}</td>
                      <td>{v?.PAN || "-"}</td>
                      <td>{v?.OPENBAL}</td>
                      <td>{v?.PREV_FY === "1" ? "YES" : "NO"}</td>
                      <td>{v?.EST_SALE}</td>
                      <td>{v?.DOM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.COM === "1" ? "YES" : "NO"}</td>
                      <td>{v?.ARB === "1" ? "YES" : "NO"}</td>
                      <td>{v?.SAMETYPE === "1" ? "YES" : "NO"}</td>
                    </tr>
                  ))}
                />
              </>
            )}
            {(custVendData?.length > 0 || vendData?.length > 0 || omcData?.length > 0 || othersData?.length > 0) && (
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "2%" }}>
                <Button onClick={handleCustVendSubmit} title={pincodeVerifying ? "Verifying Pincodes..." : custVendLoading ? "Uploading..." : "SUBMIT DATA"} disable={custVendLoading || pincodeVerifying} />
              </div>
            )}

          </div>
        }
      />
      {open && (
        <SmallModal
          okbtn
          title={"Alerts"}
          mess={mess}
          isOpen={open}
          setIsOpen={setOpen}
        />
      )}
    </>
  );
};

export default EquipmentBulkUpload;
